import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation & Header
      "skillsos": "SkillSOS",
      "signIn": "Sign In",
      "getStarted": "Get Started",
      "logout": "Logout",
      "mode": "Mode",
      "switchTo": "Switch to",
      "client": "Client",
      "specialist": "Specialist",
      "becomeSpecialist": "Become Specialist",
      "backToDashboard": "← Back to Dashboard",
      "backToServices": "Back to Services",
      "cancellationPolicy": "Cancellation Policy",
      "until24hRefund": "Until 24h before: 100% refund",
      "12to24hRefund": "12-24h before: 50% refund",
      "lessThan12hRefund": "Less than 12h: No refund",
      "paymentMethodRequired": "Payment Method Required",
      "providerConfirmedAddPayment": "Your provider has confirmed! To secure your booking, please add a payment method.",
      "actionRequired": "Action Required",
      "securePaymentNow": "Secure Payment Now",
      // Coming Soon / Wishlist Page
      "comingSoonTitle": "SkillSOS is Coming Soon!",
      "comingSoonMessage": "Just a bit more patience before we start! Want to be the first to find out about our launch?",
      "whatIsSkillSOS": "A platform that connects clients directly with specialists in cleaning and light repairs.",
      "directFromSpecialist": "Direct from the specialist. No agencies. No markups.",
      "benefitPriceTitle": "Better prices",
      "benefitPriceDesc": "No middlemen = fair price",
      "benefitSpeedTitle": "Faster",
      "benefitSpeedDesc": "From search to booking in minutes",
      "benefitVerifiedTitle": "Verified",
      "benefitVerifiedDesc": "Only verified specialists",
      "curiousAboutTime": "Curious how long cleaning takes?",
      "tryOurCalculator": "Try our free calculator",
      "goToCalculator": "Go to calculator →",
      "leaveYourEmail": "Leave us Your email.",
      "enterYourEmail": "Enter Your email",
      "notifyMe": "I want to know first!",
      "subscribing": "Subscribing...",
      "noSpamPromise": "🔒 No spam. Only important launch news.",
      "thankYou": "Thank You!",
      "stayTunedMessage": "Stay tuned, we are coming! 🚀",
      "wellNotifyYou": "We'll notify You as soon as we launch.",
      "backToCalculator": "Back to Calculator",
      "pleaseEnterValidEmail": "Please enter a valid email",
      "thankYouForSubscribing": "Thank You for subscribing!",
      "alreadySubscribed": "You are already on our list!",
      "somethingWentWrong": "Something went wrong",
      "allRightsReserved": "All rights reserved.",
      // Landing Page
      "heroTitle": "Connect with Skilled Local Service Providers",
      "heroDescription": "Find verified specialists for cleaning, handyman work, pet care, and more. Book services, manage your schedule, and pay securely all in one place with SkillSOS.",
      "findServices": "Find Services",
      "readyToExplore": "What would you like to do today?",
      "becomeASpecialist": "🏆 Become a Specialist",
      "howSkillSOSWorks": "How SkillSOS Works",
      "popularServices": "Popular Services",
      "connectSkillsLine1": "Connect Skills",
      "connectSkillsLine2": "with Needs",
      "marketplaceDescription": "The trusted marketplace where skilled professionals meet people who need their expertise. Safe, reliable, and designed for everyone.",
      
      // How it works section
      "searchAndDiscover": "Search & Discover",
      "searchDescription": "Browse verified specialists in your area. Filter by service type, ratings, and availability.",
      "bookAndSchedule": "Book & Schedule",
      "bookDescription": "Choose your preferred time slot and book instantly. Manage your appointments with ease.",
      "securePayment": "Secure Payment",
      "paymentDescription": "Pay securely through our platform. Support for multiple payment methods including Stripe and PayPal.",
      
      // Services
      "housekeeping": "Housekeeping",
      "handyman": "Handyman",
      "allServices": "All Services",
      "serviceCategories": "Service Categories",
      
      // Authentication
      "createAccount": "Create Account",
      "fullName": "Full Name",
      "email": "Email",
      "phoneNumber": "Phone Number",
      "password": "Password",
      "accountType": "Account Type",
      "clientHireServices": "Client (Hire Services)",
      "specialistProvideServices": "Specialist (Provide Services)",
      "signingIn": "Signing In...",
      "creatingAccount": "Creating Account...",
      "continueWithGoogle": "Continue with Google",
      "quickGoogleSignup": "Faster with Google",
      "quickSignupHint": "Sign up in 10 seconds to complete your booking",
      "confirmPassword": "Confirm Password",
      "register": "Register",
      "registering": "Registering...",
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email",
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 6 characters",
      "nameRequired": "Name is required",
      "phoneRequired": "Phone number is required",
      "phoneInvalid": "Invalid phone number",
      "phonePlaceholder": "+359 88 123 4567",
      "phoneHint": "Your phone will not be shown publicly",
      "phone": "Phone",
      "passwordMismatch": "Passwords do not match",
      "termsRequired": "You must accept the terms and conditions",
      "privacyRequired": "You must accept the privacy policy",
      "demoCredentials": "Demo Credentials",
      "emailPlaceholder": "your@email.com",
      "passwordPlaceholder": "Enter your password",
      "fullNamePlaceholder": "Enter your full name",
      "confirmPasswordPlaceholder": "Confirm your password",
      
      // Dashboard
      "welcomeBack": "Welcome back",
      "findAndBookTrusted": "Find and book trusted service providers",
      "manageServicesAndBookings": "Manage your services and bookings",
      "searchServices": "🔍 Search Services",
      "myBookings": "My Bookings",
      "yourNotifications": "Your Notifications",
      "recentUpdates": "Recent Updates",
      "clickToViewDetails": "Click to view details →",
      "adminVerifications": "Admin - Verifications",
      "reviewPendingVerifications": "Review pending verifications",
      "confirmedYourBooking": "confirmed your booking!",
      "serviceOn": "Service on",
      "servicesIveRequested": "Services I've requested",
      "upcoming": "Upcoming",
      "past": "Past",
      "provider": "Provider",
      "atRisk": "At Risk",
      "awaitingProviderConfirmation": "Awaiting Provider Confirmation",
      "providerNotifiedMustConfirm": "The provider has been notified and must confirm within the deadline.",
      "payment": "Payment",
      "willBeSecuredUponConfirmation": "will be secured upon confirmation",
      "messageProvider": "Message Provider",
      "cancelBooking": "Cancel Booking",
      "remove": "Remove",
      "bookingArchived": "Booking removed from list",
      "viewYourBookingRequests": "View your booking requests",
      "bookingRequests": "Booking Requests",
      "manageIncomingRequests": "Manage incoming requests",
      "reviews": "⭐ Reviews",
      "settings": "⚙️ Settings",
      "profile": "Profile",
      "myProfile": "My Profile",
      "previewMode": "Preview Mode",
      "previewModeDesc": "Explore how your provider profile will look. Register when you're ready to save and start receiving bookings!",
      "registerToSave": "Register to Save",
      "manageProfileAndServices": "Manage your profile and services",
      "myStatistics": "My Statistics",
      "thisMonth": "this month",
      "bookings": "Bookings",
      "totalEarned": "Total Earned",
      "total": "total",
      "servicesIOffer": "Services I Offer",
      "myServiceListing": "My Service Listing",
      "oneListingPerUser": "You can have one active service listing",
      "createListing": "Create Listing",
      "noListingYet": "No listing yet",
      "createListingToStart": "Create your listing to start receiving bookings",
      "createYourListing": "Create Your Listing",
      "editYourListing": "Edit Your Listing",
      "oneListingDescription": "Set up your service listing. You can offer one category of services.",
      "whatServicesDoYouOffer": "What services do you offer?",
      "selectCategoryFirst": "Select a category first...",
      "describeActivitiesHint": "List the specific services you can provide",
      "rateHint": "Average rate in Bulgaria: €10-25/hour",
      "updateListing": "Update Listing",
      "listingUpdated": "Listing updated successfully!",
      "listingCreated": "Listing created successfully!",
      "savedLocallyNotSynced": "Saved locally but could not sync to server",
      "fillAllRequiredFields": "Please fill in all required fields",
      "housekeepingServices": "Housekeeping Services",
      "handymanServices": "Handyman Services",
      "perHour": "per hour",
      "servicesOffered": "Services Offered",
      "noDescriptionProvided": "No description provided",
      "editListing": "Edit Listing",
      "pauseListing": "Pause Listing",
      "activateListing": "Activate Listing",
      "addNewService": "Add New Service",
      "editService": "Edit Service",
      "serviceName": "Service Name",
      "serviceNamePlaceholder": "e.g., Art Lessons",
      "category": "Category",
      "selectCategory": "Select category",
      "hourlyRate": "Hourly Rate",
      "minimumServiceFee": "Minimum Service Fee",
      "optional": "Optional",
      "legalAgreements": "Legal Agreements",
      "agreeTerms": "I agree to the",
      "acknowledgePrivacy": "I acknowledge that I have read and understand the",
      "consentMarketing": "I consent to receive marketing communications and promotional offers via email",
      "requiredFields": "Required fields. You can withdraw your consent at any time by contacting",
      "minimumFeePlaceholder": "e.g., 30",
      "minimumFeeHint": "Clients will pay at least this amount, regardless of booking duration",
      "description": "Description",
      "describeYourService": "Describe your service...",
      "cancel": "Cancel",
      "updateService": "Update Service",
      "addService": "Add Service",
      "noServicesYet": "You haven't added any services yet",
      "addYourFirstService": "Add Your First Service",
      "hour": "hour",
      "hours": "hours",
      "minimum": "minimum",
      "minimumBooking": "Minimum booking",
      "minimumBookingRequirement": "Minimum Booking Requirement",
      "specialistRequiresMinimum": "This specialist requires a minimum booking of",
      "acceptingBookings": "Accepting Bookings",
      "checkCalendarForAvailability": "Check the calendar when booking to see available times",
      "scheduleNotConfigured": "Schedule not yet configured",
      "edit": "Edit",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "active": "Active",
      "inactive": "Inactive",
      "paymentMethods": "Payment Methods",
      "managePaymentMethodsDesc": "Manage your saved payment methods for quick booking",
      "addCard": "Add Card",
      "noPaymentMethodsYet": "No payment methods saved yet",
      "addYourFirstCard": "Add Your First Card",
      "viewBookings": "View bookings",
      "editProfile": "Edit Profile",
      "profileUpdatedSuccessfully": "Profile updated successfully!",
      "name": "Name",
      "newUser": "New User",
      "nameLastNamePlaceholder": "Name Last name",
      "yourName": "Your name",
      "enterName": "Enter your name",
      "availability": "Availability",
      "earnings": "Earnings",
      "myCalendar": "My Calendar",
      "manageProfile": "Manage Profile",
      "whatServiceDoYouNeed": "What service do you need today?",
      "specialistDashboard": "🏆 Specialist Dashboard",
      "manageYourServicesAndAppointments": "Manage your services and appointments.",
      
      // Verification
      "verification": "Verification",
      "verificationStatus": "Verification Status",
      "notSubmitted": "Not Submitted",
      "pending": "Pending Review",
      "verifiedBadge": "Verified",
      "rejectedBadge": "Rejected",
      "submitVerification": "Submit for Verification",
      "resubmitVerification": "Resubmit Verification",
      "uploadDocuments": "Upload Documents",
      "documentType": "Document Type",
      "selectDocumentType": "Select document type",
      "phoneVerification": "Phone/Email/Photo",
      "idDocument": "ID Document",
      "proficiencyDocument": "Proficiency Document", 
      "otherDocument": "Other",
      "chooseFile": "Choose File",
      "uploadedFiles": "Uploaded Files",
      "noFilesUploaded": "No files uploaded yet",
      "removeFile": "Remove",
      "additionalNotes": "Additional Notes",
      "notesPlaceholder": "Add any notes for the admin reviewing your documents...",
      "submitForReview": "Submit for Review",
      "verificationRequirements": "Verification Requirements",
      "requirementDescription": "Upload at least 2 documents from the following categories:",
      "phoneEmailPhoto": "Phone number / Email / Photo",
      "idDocuments": "ID, Passport, or Driving License",
      "proficiencyDocs": "Job contracts, references, certificates",
      "otherDocs": "Work photos, criminal record, insurance",
      "verificationPending": "Your verification is pending admin review",
      "verificationApproved": "Your profile is verified!",
      "verificationRejected": "Verification rejected. Please review feedback and resubmit.",
      "adminFeedback": "Admin Feedback",
      "fileTooLarge": "File is too large. Maximum size is 5MB",
      "minimumTwoDocuments": "Please upload at least 2 documents",
      "verificationSubmitted": "Verification submitted successfully",
      "verificationFailed": "Failed to submit verification",
      "viewAndManageAppointments": "View and manage your appointments",
      "updateServicesAndRates": "Update your services and rates", 
      "trackIncomeAndPayments": "Track your income and payments",
      "openFullSpecialistDashboard": "🏢 Open Full Specialist Dashboard",
      
      // Profile/Settings Forms
      "profileImage": "Profile Image",
      "chooseFile": "Choose File",
      "noFileSelected": "no file selected",
      "uploadSquareImageRecommended": "Upload a square image (recommended). Max size: 5MB.",
      "servicesOffered": "Services Offered",
      "hourlyRate": "Hourly Rate",
      "currency": "Currency", 
      "minimumServiceFee": "Minimum Service Fee",
      "yearsOfExperience": "Years of Experience",
      "bio": "Bio",
      "minimumServiceFeeDescription": "Minimum Service Fee: If set, clients will pay at least this amount even for services shorter than 1 hour.",
      
      // Enhanced Dashboard
      "quickActions": "Quick Actions",
      "bookAgain": "Book Again",
      "findNewServices": "Find New Services",
      "manageBookings": "Manage Bookings",
      "savedSpecialists": "Saved Specialists",
      "totalBookings": "Total Bookings",
      "activeBookings": "Active Bookings",
      "savedFavorites": "Saved Favorites",
      "totalSpent": "Total Spent",
      "recentActivity": "Recent Activity",
      "viewAll": "View All",
      "noBookingsYet": "No bookings yet",
      "readyToFindYourNextService": "Ready to find your next service?",
      "recommendedForYou": "Recommended For You",
      "topRatedSpecialists": "Top-rated specialists in your area",
      "savedSearches": "Saved Searches",
      "noRecommendations": "No recommendations available yet",
      "noSavedSearches": "No saved searches",
      "createSearch": "Create Search",
      "thisMonth": "This Month",
      "servicesBooked": "Services Booked",
      "amountSpent": "Amount Spent", 
      "newFavorites": "New Favorites",
      "needSomethingDone": "Need Something Done?",
      "findTrustedSpecialists": "Find trusted specialists for any task",
      "browseAllServices": "Browse All Services",
      "findNearbySpecialists": "Find Nearby Specialists",
      "loadingDashboard": "Loading Dashboard...",

      // Enhanced Specialist Profile
      "verified": "Verified",
      "new": "New",
      "review": "review",
      "reviews": "reviews",
      "yearsExp": "Years Experience",
      "reviewsCount": "reviews",
      "satisfaction": "Satisfaction",
      "responseTime": "Response Time",
      "availableToday": "Available Today",
      "bookThisSpecialist": "Book This Specialist",
      "startingFrom": "Starting from",
      "getInstantQuote": "Get instant quote and book now",
      "bookNow": "Book Now",
      "bookService": "Book Service",
      "selectService": "Select Service",
      "chooseService": "Choose a service",
      "selectDate": "Select Date",
      "selectTime": "Select Time",
      "chooseTime": "Choose time",
      "duration": "Duration",
      "hour": "hour",
      "hours": "hours",
      "serviceAddress": "Service Address",
      "enterServiceAddress": "Enter service address",
      "specialInstructions": "Special Instructions",
      "anySpecialRequirements": "Any special requirements or notes",
      "pricingSummary": "Pricing Summary",
      "serviceRate": "Service Rate",
      "totalEstimate": "Total Estimate",
      "serviceSubtotal": "Service Amount",
      "serviceFee": "Service Fee",
      "serviceFeeTooltip": "This fee covers secure payment processing and platform maintenance",
      "totalToPay": "Total to Pay",
      "paymentMethod": "Payment method",
      "payCash": "Pay in cash (at the meeting)",
      "payCard": "Pay by card",
      "paymentHoldNote": "The amount will be held securely until the service is completed. Payment to the specialist is made after your confirmation.",
      "applies": "applies",
      "confirmBooking": "Confirm Booking",
      
      // Provider earnings
      "earningsBreakdown": "Your Earnings",
      "serviceAmount": "Service Amount",
      "platformFee": "SkillSOS Fee",
      "stripeFee": "Stripe Fee",
      "youReceive": "You Receive",
      "noBookingsYet": "No bookings yet",
      "instructions": "Instructions",
      "accept": "Accept",
      "decline": "Decline",
      "requester": "Requester",
      "respondBy": "Respond by",
      "pendingCount": "pending",
      "confirmedCount": "confirmed",
      "loadingRequests": "Loading requests...",
      "hour": "hour",
      "hours": "hours",
      "declineBooking": "Decline Booking",
      "declineBookingDescription": "Please provide a reason for declining this booking request.",
      "declineReasonPlaceholder": "e.g., Schedule conflict, out of service area, etc.",
      "confirmDecline": "Confirm Decline",
      "pleaseProvideDeclineReason": "Please provide a reason for declining",
      "bookingAccepted": "Booking accepted! Requester has been notified.",
      "messageRequester": "Message Requester",
      "cancelBooking": "Cancel Booking",
      "reasonForCancellation": "Reason for cancellation",
      "selectReason": "Select a reason...",
      "scheduleConflict": "Schedule conflict",
      "emergency": "Emergency",
      "cannotProvideService": "Cannot provide service",
      "clientRequest": "Client request",
      "serviceNoLongerNeeded": "Service no longer needed",
      "serviceCurrentlyUnavailable": "This service is currently unavailable",
      "addressAfterPayment": "Address will be visible after client payment",
      "cancelledBookings": "Cancelled Bookings",
      "yourPayment": "Your Payment",
      "ofBooking": "of booking",
      "fullCancellationFee": "Full cancellation fee",
      "clientCancelledEarly": "Client cancelled early - you receive full cancellation fee",
      "clientCancelledWithin24h": "Client cancelled within 24h - partial payment",
      "clientCancelledLate": "Client cancelled late - you receive full amount",
      "other": "Other",
      "cancellationPolicy": "Cancellation Policy",
      "cancellationPolicyText": "Penalties may apply based on timing and terms.",
      "date": "Date",
      "at": "at",
      "amount": "Amount",
      "bookingConfirmedDesc": "Your booking is confirmed by the provider.",
      "bookingConfirmed": "Booking Confirmed",
      "payment": "Payment",
      "heldSecurely": "held securely",
      "fundsReleasedAfterService": "Funds will be released to provider after service completion",
      "markCompleted": "Mark Completed",
      "chat": "Chat",
      "chatWith": "Chat with",
      
      "cannotBookYourself": "You cannot book yourself",
      "thisIsYourProfile": "This is your profile",
      "goToMyProfile": "Go to My Profile to manage your services",
      "notSet": "Not set",
      "processing": "Processing",
      "message": "Message",
      "call": "Call",
      "securePayment": "Secure Payment",
      "instantBooking": "Instant Booking",
      "support247": "24/7 Support",

      // Hours Calculator
      "hoursCalculator": "Hours Calculator",
      "needHelpEstimating": "Not sure how many hours to book?",
      "calculatorDescription": "Answer a few questions and we'll recommend the optimal duration.",
      "propertySize": "Property size (sq.m)",
      "sqmHint": "100 sq.m ≈ 2.5 hours cleaning",
      "numberOfBathrooms": "Number of bathrooms",
      "bathroomHint": "+30 min for each bathroom",
      "balconySize": "Balcony/Terrace (sq.m)",
      "balconyPlaceholder": "e.g., 10",
      "balconyHint": "10 sq.m ≈ +15 min",
      "customPrice": "Provider's price (optional)",
      "customPricePlaceholder": "e.g., 25",
      "customPriceHint": "Enter a price you were quoted to compare",
      "customPriceLabel": "Provider's quoted price (EUR/hour)",
      "priceComparison": "Price comparison",
      "fairPrice": "Fair price! This is within the normal range.",
      "highPrice": "This seems high. Average rate is {{avg}} EUR/hour for this type of cleaning.",
      "lowPrice": "Great deal! This is below the average rate of {{avg}} EUR/hour.",
      "avgRateRange": "Average market rate: {{min}}-{{max}} EUR/hour",
      "totalCostEstimate": "Estimated total cost",
      "basedOnHours": "Based on {{hours}} of work",
      "ironingNeeded": "Ironing needed",
      "ironingHint": "+1 hour for ironing",
      "frenchWindows": "French windows",
      "frenchWindowHint": "+30 min each",
      "standardWindows": "Standard windows",
      "standardWindowHint": "+15 min each",
      "recommendedDuration": "Recommended duration:",
      "applyRecommendation": "Apply",
      "calculatorApplied": "Duration applied!",

      // Review System
      "leaveReview": "Leave Review",
      "reviewSubmittedSuccess": "Review submitted successfully!",
      "reviewSubmitFailed": "Failed to submit review",
      "leaveAReview": "Leave a Review",
      "shareYourExperience": "Share your experience with",
      "overallRating": "Overall Rating",
      "required": "*",
      "writeYourReview": "Write your review (optional)",
      "tellUsMore": "Tell us more about your experience...",
      "reviewPromptTitle": "How was the service?",
      "reviewPromptMessage": "You have a completed service that you haven't reviewed yet. Your opinion helps other users!",
      "moreReviewsPending": "more to review",
      "reviewNow": "Review Now",
      "later": "Later",
      "withPerson": "with",
      "rateAttributes": "Rate specific attributes",
      "punctual": "On Time / Punctual",
      "professional": "Professional",
      "respectful": "Respectful",
      "communicative": "Good Communication",
      "friendly": "Friendly & Pleasant",
      "cancel": "Cancel",
      "submitReview": "Submit Review",
      "submitting": "Submitting...",
      "myReviews": "My Reviews",
      "totalReviews": "Total Reviews",
      "noReviewsYet": "No Reviews Yet",
      "reviewsWillAppearHere": "Reviews you receive will appear here",
      "star": "star",
      "stars": "stars",
      "howWas": "How was",
      "additionalComments": "Additional Comments (Optional)",
      "shareMoreDetails": "Share more details about your experience...",
      "characters": "characters",
      "note": "Note",
      "reviewVisibilityNote": "Your review will be visible to {revieweeName} only after both of you have submitted reviews, or after 4 days.",
      "thisUser": "this user",

      // Booking Management
      "servicesPeopleWantToBook": "Services people want to book from me",
      "pendingRequests": "Pending Requests",
      "noPendingRequests": "No pending requests",
      "newBookingRequestsWillAppear": "New booking requests will appear here",
      "upcomingConfirmed": "Upcoming Confirmed",
      "noConfirmedBookings": "No confirmed bookings",
      "acceptedBookingsWillAppear": "Accepted bookings will appear here",
      "completedBookings": "Completed Bookings",
      "noCompletedBookings": "No completed bookings",
      "completedBookingsWillAppear": "Completed bookings will appear here",
      "weeklyAvailability": "Weekly Availability",
      "editSchedule": "Edit Schedule",
      "scheduleDescription": "Schedule Description",
      "notAvailable": "Not Available",
      "closed": "Closed",
      "specialist": "specialist",
      "inbox": "Inbox",
      "inboxSubtitle": "Manage your conversations and messages",
      "newMessage": "New Message",
      "searchMessages": "Search messages...",
      "noConversations": "No conversations yet",
      "selectConversation": "Select a conversation to view messages",
      "selectConversationHint": "Choose a contact from the list to start chatting",
      "typeMessage": "Type your message...",
      "typeYourMessage": "Type your message here...",
      "send": "Send",
      "sendMessage": "Send Message",
      "messageSentSuccess": "Message sent successfully!",
      "inquiryFrom": "Inquiry from",
      "to": "To",
      "from": "From",
      "selectContact": "Select a contact",
      "active": "Active",
      "yesterday": "Yesterday",
      "more": "More",
      "showLess": "Show Less",
      "termsDescription": "Read our terms of service and conditions",
      "privacyDescription": "Learn how we protect your privacy and data",
      "overview": "Overview",
      "portfolio": "Portfolio",
      "servicesSpecialties": "Services & Specialties",
      "experienceLevel": "Experience level",
      "expert": "Expert",
      "serviceArea": "Service Area",
      "primaryLocation": "Primary Location",
      "serviceRadius": "Service Radius",
      "within": "within",
      "radius": "radius",
      "travelFee": "Travel Fee",
      "free": "Free",
      "freeRegistrationBanner": "FREE REGISTRATION - No fees, start earning now!",
      "pricingPolicies": "Pricing & Policies",
      "hourlyRate": "Hourly Rate",
      "minimumFee": "Minimum Fee",
      "cancellationPolicy": "Cancellation Policy",
      "flexible": "Flexible",
      "paymentMethods": "Payment Methods",
      "card": "Card",
      "cash": "Cash",
      "customerReviews": "Customer Reviews",
      "helpful": "Helpful",
      "beFirstToReview": "Be the first to review this specialist!",
      "selectDateFirst": "Select a date first",
      "noAvailableTimesForDate": "No available times for this date",
      "loadingAvailableTimes": "Loading available times...",
      "workPortfolio": "Work Portfolio",
      "seeExamplesOfWork": "See examples of previous work",
      "availabilitySchedule": "Availability & Schedule",
      "weeklySchedule": "Weekly Schedule",
      "monday": "Monday",
      "tuesday": "Tuesday", 
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "closed": "Closed",
      "nextAvailable": "Next Available",
      "availableToday": "Available Today",
      "nextSlot": "Next slot",
      "today": "Today",
      "readyToBook": "Ready to Book?",
      "joinHundredsOfSatisfiedCustomers": "Join hundreds of satisfied customers who trusted",
      "browseMoreSpecialists": "Browse More Specialists",
      "redirectingToAddCard": "Redirecting to add your card...",
      "addedToFavorites": "Added to favorites!",
      "removedFromFavorites": "Removed from favorites",
      "linkCopied": "Link copied to clipboard",
      "copyLinkManually": "Couldn't copy automatically. Please copy the link from the address bar.",
      "pleaseSignInToBook": "Please sign in to book a service",
      "bookingCreatedSuccessfully": "Booking created successfully!",
      "bookingFailed": "Booking failed. Please try again.",
      "noAvailableSlotsOnDate": "No available slots on this date",
      "failedToLoadAvailableTimes": "Failed to load available times",
      "pleaseSelectDate": "Please select a date",
      "pleaseSelectTime": "Please select a time",
      "pleaseEnterAddress": "Please enter service address",
      "providerDoesNotWorkOn": "Provider does not work on",
      "paymentCompletedBookingConfirmed": "Payment completed! Your booking is confirmed.",
      "paymentFailedTryAgain": "Payment failed. Please try again from My Bookings page.",
      "redirectingToStripe": "Redirecting to Stripe...",
      "pleaseWait": "Please wait...",
      "noPastBookings": "No past bookings",
      "bookingHistoryWillAppearHere": "Your booking history will appear here",
      "pleaseAddPaymentMethodFirst": "Please add a payment method before booking",
      "addPaymentMethod": "Add Payment Method",
      "startConversation": "Start a conversation",
      "sendFirstMessage": "Send your first message to this specialist",

      // Enhanced Search & Discovery
      "findYourPerfectSpecialist": "Find Your Perfect Specialist",
      "discoverTrustedProfessionals": "Discover trusted professionals for any task",
      "searchServices": "Search services or specialists...",
      "searchByKeyword": "Search by keyword (e.g. painting, assembly, cleaning...)",
      "location": "Location",
      "allCategories": "All Categories",
      "filters": "Filters",
      "mapView": "Map View",
      "priceRange": "Price Range",
      "minimumRating": "Minimum Rating",
      "anyRating": "Any Rating",
      "availability": "Availability",
      "anytime": "Anytime",
      "thisWeek": "This Week",
      "weekends": "Weekends",
      "distance": "Distance",
      "anywhere": "Anywhere",
      "clearFilters": "Clear Filters",
      "saveSearch": "Save Search",
      "saveThisSearch": "Save This Search",
      "searchName": "Search Name",
      "enterSearchName": "Enter search name",
      "enableAlerts": "Enable alerts for new specialists",
      "saveWithAlerts": "Save with Alerts",
      "searchSaved": "Search saved successfully!",
      "specialistFound": "specialist found",
      "specialistsFound": "specialists found",
      "for": "for",
      "in": "in",
      "sortBy": "Sort by",
      "topRated": "Top Rated",
      "random": "Random",
      "priceLowToHigh": "Price ↑",
      "priceHighToLow": "Price ↓",
      "byLocation": "Location",
      "nearest": "Nearest",
      "otherCity": "Other city...",
      "enterCity": "Enter city...",
      "tryAdjustingFilters": "Try adjusting your filters or search terms",
      "browseAllCategories": "Browse All Categories",
      "loadMoreResults": "Load More Results",
      "addedToFavorites": "Added to favorites!",
      
      // Enhanced Header & Notifications
      "switchMode": "Switch",
      "switching": "Switching...",
      "notifications": "Notifications",
      "viewAllNotifications": "View All Notifications",
      "more": "more",
      "noNotifications": "No new notifications",
      "justNow": "Just now",
      "ago": "ago",
      "helpCenter": "Help Center",
      "dashboard": "Dashboard",
      "back": "← Back",
      
      // Header Dropdown translations
      "findOnMap": "Find on Map",
      "browseAllServices": "Browse All Services",
      "browseServices": "Browse Services", 
      "myDashboard": "My Dashboard",
      "mySpecialistDashboard": "My Specialist Dashboard",
      "manageAvailability": "Manage Availability",
      "viewEarnings": "View Earnings",
      "profileSettings": "Profile Settings",
      "signInAsClient": "Sign In as Client",
      "signInAsSpecialist": "Sign In as Specialist",
      "learnMore": "Learn More",
      
      // Footer translations
      "footerDescription": "Connecting clients with trusted specialists for all your home service needs. Safe, reliable, and professional.",
      "services": "Services",
      "company": "Company",
      "support": "Support",
      "legal": "Legal",
      "aboutUs": "About Us",
      "careers": "Careers",
      "blog": "Blog",
      "press": "Press",
      "investors": "Investors",
      "safety": "Safety",
      "contact": "Contact",
      "community": "Community",
      "accessibility": "Accessibility",
      "termsOfService": "Terms of Service",
      "cookiePolicy": "Cookie Policy",
      "dataPolicy": "Data Policy",
      "sitemap": "Sitemap",
      "allRightsReserved": "All rights reserved.",
      "availableWorldwide": "Available worldwide",
      
      // Map Location Selector & Search Results
      "findSpecialistsOnMap": "Find Specialists on Map",
      "discoverNearbySpecialists": "Discover trusted specialists in your area using our interactive map",
      "searchByLocation": "Search by Location",
      "enterLocationPlaceholder": "Enter city, address or landmark...",
      "searchLocation": "Search Location",
      "findNearby": "Find Nearby",
      "useCurrentLocationDescription": "Use your current location to find specialists around you",
      "locating": "Locating",
      "findSpecialistsNearby": "Find Specialists Nearby",
      "popularLocations": "Popular Locations",
      "verifiedSpecialists": "Verified Specialists",
      "averageResponseTime": "Average Response Time",
      "averageRating": "Average Rating",
      "findingSpecialists": "Finding specialists...",
      "specialistsFound": "specialists found",
      "nearby": "Nearby",
      "filters": "Filters",
      "away": "away",
      "online": "Online",
      "book": "Book",
      "currentLocation": "Current Location",
      "backToDashboard": "Back to Dashboard",
      "browseByCategory": "Browse by Category", 
      "advancedSearch": "Advanced Search",
      "allCities": "All Cities",
      "city": "City",
      "selectCity": "Select city",
      "maxHourlyRate": "Max Hourly Rate",
      "useAdvancedFiltersToFindExactly": "Use advanced filters to find exactly what you need",
      "viewMode": "View Mode",
      
      // Beautiful Home Page
      "trustedBy": "Trusted by",
      "verifiedSpecialists": "Verified Specialists",
      "connectSkillsWithNeeds": "Connect Skills with Needs",
      "trustedMarketplaceDescription": "The trusted marketplace where skilled professionals meet people who need their expertise. Safe, reliable, and designed for everyone.",
      "overwhelmedWithTasks": "Are you overwhelmed with tasks?",
      "overwhelmedDescription": "From house cleaning to handyman work, - find verified specialists who can help you get things done.",
      "goodAtSomething": "Are you good at something?",
      "goodAtSomethingDescription": "Turn your skills into income! Join thousands of specialists earning money doing what they love, on their own schedule.",
      "findYourSpecialist": "Find Your Specialist",
      "becomeSpecialist": "Become a Specialist",
      "verifiedTrustedSpecialists": "Verified & trusted specialists",
      "securePaymentProtection": "Secure payment protection",
      "customerSupport247": "24/7 customer support",
      "setOwnRatesSchedule": "Set your own rates & schedule",
      "guaranteedPayments": "Guaranteed payments",
      "buildReputation": "Build your reputation",
      "popularServices": "Popular Services",
      "findSpecialistsForServices": "Find specialists for the services you need most",
      "viewAllServices": "View All Services",
      "happyCustomers": "Happy Customers",
      "servicesCompleted": "Services Completed",
      "readyToGetStarted": "Ready to Get Started?",
      "joinThousandsTrust": "Join thousands of people who trust SkillSOS for their service needs",
      "iNeedServices": "I Need Services",
      "iOfferServices": "I Offer Services",
      "copyrightSkillSOS": "© 2024 SkillSOS. Connecting skills with needs, safely and reliably.",
      "directConnection": "Direct Connection",
      "noAgencies": "No Agencies",
      "securePayments": "Secure Payments",
      "flexibleSchedule": "Flexible Schedule",
      "clientBookingComingSoon": "Client booking will be available soon!",
      
      // Auth Modal - Multi-step flow
      "welcomeToSkillSOS": "Welcome to SkillSOS",
      "welcomeBack": "Welcome back!",
      "createAccount": "Create Account",
      "enterEmailToContinue": "Enter your email to continue",
      "enterEmailToLogin": "Enter your email to sign in",
      "differentUser": "Different user?",
      "useNewEmail": "Enter a new email",
      "justEnterEmail": "Just enter your email",
      "emailPlaceholder": "Your email address",
      "continue": "Continue",
      "checking": "Checking...",
      "or": "or",
      "continueWithGoogle": "Continue with Google",
      "quickGoogleSignup": "Faster with Google",
      "quickSignupHint": "Sign up in 10 seconds to complete your booking",
      "changeEmail": "Change email",
      "passwordPlaceholder": "Your password",
      "signingIn": "Signing in...",
      "signIn": "Sign In",
      "noAccount": "Don't have an account?",
      "createOne": "Create one",
      "fullNamePlaceholder": "Your full name",
      "createPassword": "Create a password",
      "confirmPasswordPlaceholder": "Confirm your password",
      "creatingAccount": "Creating account...",
      "alreadyHaveAccount": "Already have an account?",
      "emailRequired": "Please enter your email",
      "emailInvalid": "Please enter a valid email",
      "step1of2": "Step 1 of 2",
      "step2of2": "Step 2 of 2",
      "agreeToLegal": "I agree to the",
      "agreeToTerms": "I agree to the",
      "agreeToPrivacy": "I agree to the",
      "and": "and",
      "legalRequired": "Please accept the terms and privacy policy",
      "passwordRequired": "Please enter your password",
      "passwordMinLength": "Password must be at least 6 characters",
      "passwordMismatch": "Passwords do not match",
      "nameRequired": "Please enter your name",
      "phoneRequired": "Phone number is required",
      "phoneInvalid": "Invalid phone number",
      "phonePlaceholder": "+359 88 123 4567",
      "phoneHint": "Your phone will not be shown publicly",
      "phone": "Phone",
      "termsRequired": "You must accept the terms of service",
      "privacyRequired": "You must accept the privacy policy",
      "termsAndConditions": "Terms and Conditions",
      "privacyPolicy": "Privacy Policy",
      "iAcceptThe": "I accept the",
      "and": "and",
      "iAgreeToReceive": "I agree to receive marketing communications",
      "weWillNotifyYou": "We will notify you when this feature is ready.",
      "understood": "Got it",
      "photoUploadedSuccessfully": "Photo uploaded successfully!",
      "photoUploadFailed": "Failed to upload photo. Please try again.",
      "activitiesOffered": "What activities do you offer?",
      "housekeepingPlaceholder": "e.g. regular cleaning, deep cleaning, laundry, ironing, window cleaning, organizing...",
      "handymanPlaceholder": "e.g. furniture assembly, lightbulb changing, TV mounting, painting touch-ups, shelf installation, minor plumbing...",
      "handymanGuidanceTitle": "💬 Recommendation for handyman services",
      "handymanGuidanceText": "Before booking, we recommend sending a message to the specialist describing your task. This way they can advise you on how much time to book.",
      "sendMessageFirst": "Send a message first",
      "confirmDeleteService": "Are you sure you want to delete this service?",
      "serviceDeleted": "Service deleted",
      "serviceDeletedLocally": "Service deleted locally but could not sync to server",
      "selectCategoryFirst": "Select a category first...",
      "describeActivitiesHint": "List the specific services you can provide",
      "serviceActivated": "Service activated",
      "serviceDeactivated": "Service deactivated",
      "statusSyncError": "Status updated locally but could not sync to server",
      "scheduleSavedSuccessfully": "✅ Schedule saved successfully!",
      "failedToSaveSchedule": "❌ Failed to save schedule. Please try again.",
      "rateHintCleaning": "Average rate in Bulgaria: €8-20/hour",
      "rateHintHandyman": "Average rate in Bulgaria: €10-25/hour",
      "minimumHours": "Minimum hours",
      "minimumHoursHint": "Minimum booking duration",
      "minHours": "min",
      "confirmRemoveCancelledBooking": "Remove this cancelled booking from your list?",
      "bookingRemoved": "Booking removed",
      "failedToRemoveBooking": "Failed to remove booking",
      "pleaseLogIn": "Please log in to remove bookings",
      "loginSuccessful": "Login successful!",
      "loginFailed": "Login failed",
      "invalidCredentials": "Invalid email or password",
      "userNotFound": "User not found",
      "comingSoon": "Coming Soon",
      "bookingComingSoon": "Client booking will be available soon!",
      "bookingComingSoonDesc": "We're putting the finishing touches on our booking system to ensure you have the best experience. Stay tuned!",
      "bookingComingSoonTip": "In the meantime, feel free to message the specialist directly to discuss your needs.",
      "messageInstead": "Message Specialist",
      "locationNotProvided": "Location not provided",
      "registrationSuccessful": "Registration successful!",
      "registrationFailed": "Registration failed",
      "logoutSuccessful": "Logged out successfully",
      "pleaseAcceptTerms": "Please accept the terms and conditions",
      "pleaseAcceptPrivacy": "Please accept the privacy policy",
      "tellUsAboutYourself": "Tell us about yourself...",
      "paymentSetupTemporarilyUnavailable": "Payment setup is temporarily unavailable. We're working on it! Please try again later.",
      "cityUpdatedSuccessfully": "City updated successfully",
      "failedToSaveLocation": "Failed to save location. Please try again.",
      "serviceArea": "Service Area",
      "selectServiceArea": "Where do you offer services?",
      "serviceAreaHint": "Select the city where you provide services",
      "selectYourCity": "Select your city...",
      "locationRequired": "Please select your city/location",
      "addBioInEditProfile": "Add a personal bio in Edit Profile",
      
      // Location Modal
      "location_modal.title": "Where can we help you?",
      "location_modal.subtitle": "We'll show you the best specialists nearby 😊",
      "location_modal.select_placeholder": "Select your city...",
      "location_modal.skip": "Maybe Later",
      "location_modal.continue": "Continue",
      "location_modal.varna": "Varna",
      "location_modal.sofia": "Sofia",
      "location_modal.plovdiv": "Plovdiv",
      "location_modal.burgas": "Burgas",
      "location_modal.other": "Other city",
      
      // How It Works Section
      "howItWorks": "How It Works",
      "forClients": "For Clients",
      "forClientsPricesFrom": "For clients, prices from",
      "pricesFrom": "prices from",
      "forSpecialists": "For Specialists",
      "forSpecialistsEarn": "For specialists, earn",
      "earn": "earn",
      "howItWorks_client_step1": "Register",
      "howItWorks_client_step1_desc": "Create your account on the website",
      "howItWorks_client_step2": "Browse specialists",
      "howItWorks_client_step2_desc": "Search by location, service type, or rating",
      "howItWorks_client_step3": "Check availability",
      "howItWorks_client_step3_desc": "View schedules and estimate service duration with our calculator",
      "howItWorks_client_step4": "Send request",
      "howItWorks_client_step4_desc": "Choose your preferred day, time, and duration",
      "howItWorks_client_step5": "Get confirmation",
      "howItWorks_client_step5_desc": "Check notifications or My Bookings",
      "howItWorks_client_step6": "Welcome your specialist",
      "howItWorks_client_step6_desc": "Relax and let the expert handle it",
      "howItWorks_specialist_step1": "Register",
      "howItWorks_specialist_step1_desc": "Create your specialist account",
      "howItWorks_specialist_step2": "Create profile",
      "howItWorks_specialist_step2_desc": "Add your details and payout info",
      "howItWorks_specialist_step3": "List services",
      "howItWorks_specialist_step3_desc": "Set your hourly rate and schedule",
      "howItWorks_specialist_step4": "Check requests",
      "howItWorks_specialist_step4_desc": "Monitor notifications for new bookings",
      "howItWorks_specialist_step5": "Accept & complete",
      "howItWorks_specialist_step5_desc": "Confirm bookings and deliver great service",
      "howItWorks_specialist_step6": "Get paid",
      "howItWorks_specialist_step6_desc": "Receive payment within 24 hours",
      
      // Why Join Us Section
      "whyJoinUs": "Why Join Us?",
      "whyJoinUsSubtitle": "Discover the benefits for clients and service providers",
      "whyJoinAsClient": "For Clients",
      "whyJoinAsProvider": "For Providers",
      "whyClient_fast": "Fast & Convenient",
      "whyClient_fast_desc": "Get help quickly without agency delays. Direct connection to verified specialists.",
      "whyClient_affordable": "Affordable Prices",
      "whyClient_affordable_desc": "No agency markups. Choose a provider that fits your budget.",
      "whyClient_reviews": "Verified Reviews",
      "whyClient_reviews_desc": "See real reviews from other clients before you book.",
      "whyClient_transparent": "Transparent Pricing",
      "whyClient_transparent_desc": "Know the exact cost upfront. No hidden fees or surprises.",
      "whyProvider_independent": "Work for Yourself",
      "whyProvider_independent_desc": "Be your own boss. Accept or decline requests as you wish.",
      "whyProvider_flexible": "Flexible Schedule",
      "whyProvider_flexible_desc": "Set your own timetable. Work when it suits you.",
      "whyProvider_pricing": "Set Your Own Rates",
      "whyProvider_pricing_desc": "Decide your hourly fee. You control your earnings.",
      "whyProvider_secure": "Secured Payments",
      "whyProvider_secure_desc": "No negotiations with clients. They pay upfront, you get paid after the job is done.",
      "findSpecialist": "Find a Specialist",
      "becomeProvider": "Become a Provider",
      
      // Specialists & Booking
      "findYourPerfectSpecialist": "Find Your Perfect Specialist",
      "browseOurTrustedSpecialists": "Browse our trusted specialists and book the service you need.",
      "featuredSpecialists": "Featured Specialists",
      "loadingSpecialists": "Loading specialists...",
      "specialistNotFound": "Specialist Not Found",
      "specialistNotFoundDesc": "The specialist you're looking for doesn't exist or has been removed.",
      "browseAllSpecialists": "Browse All Specialists",
      "viewProfileAndBook": "View Profile & Book",
      "viewProfile": "View Profile",
      "bookThisSpecialist": "Book This Specialist",
      "startingFrom": "Starting from",
      "hourly": "/hour",
      "yearsExperience": "years experience",
      "noReviews": "No reviews yet. Be the first to book and review!",
      "reviewsCount": "reviews",
      "bookNowSpecialist": "Book {name} Now",
      "readyToBook": "Ready to Book?",
      "joinHundredsOfSatisfied": "Join hundreds of satisfied customers who trusted {name}",
      "noSpecialistsFound": "No specialists found",
      "tryDifferentCategory": "Try selecting a different category or check back later.",
      "getStartedToPost": "Get Started to Post Your Service",
      "joinThousandsSatisfied": "Join thousands of satisfied customers and service providers",
      "noSpecialistsAvailable": "No specialists are available at the moment.",
      "noSpecialistsForCategory": "No specialists found for {category}.",
      "viewAllCategories": "View All Categories",
      "specialistsFound": "specialist found",
      "specialistsFoundPlural": "specialists found",  
      "specialistsFoundFor": "specialist found for",
      "specialistsFoundPluralFor": "specialists found for",
      
      // Booking Form
      "date": "Date",
      "time": "Time",
      "selectTime": "Select time",
      "duration": "Duration",
      "durationHours": "Duration (hours)",
      "hour": "hour",
      "hours": "hours",
      "serviceAddress": "Service Address",
      "enterServiceAddress": "Enter service address",
      "specialInstructions": "Special Instructions",
      "specialRequirements": "Any special requirements or notes",
      "estimatedTotal": "Estimated Total:",
      "minimumFeeApplies": "*Minimum fee of €{fee} applies",
      "confirmBooking": "Confirm Booking",
      "bookingCreatedSuccessfully": "Booking created successfully!",
      "bookingFailed": "Booking failed. Please try again.",
      "pleaseSignInToBook": "Please sign in to book a service",
      "getInstantQuote": "Get an instant quote for your service",
      "securePaymentSupport": "✓ Secure payment • ✓ Instant booking • ✓ 24/7 support",
      
      // Specialist Profile
      "location": "📍 Location",
      "pricing": "💰 Pricing",
      "minimumServiceFee": "Minimum service fee:",
      "servicesAndSpecialties": "Services & Specialties",
      "customerReviews": "Customer Reviews",
      "reviewsComingSoon": "Reviews coming soon...",
      "professionalDescription": "Professional house cleaner with 5+ years experience. Detailed cleaning, eco-friendly products available.",
      
      // Common actions
      "search": "Search",
      "book": "Book",
      "bookNow": "Book Now",
      "cancel": "Cancel",
      "save": "Save",
      "update": "Update",
      "delete": "Delete",
      "edit": "Edit",
      "loading": "Loading...",
      "saving": "Saving...",
      "saveChanges": "Save Changes",
      "updating": "Updating...",
      "uploading": "Uploading...",
      "submit": "Submit",
      "confirm": "Confirm",
      "view": "View",
      "close": "Close",
      "next": "Next",
      "previous": "Previous",
      "back": "Back",
      
      // Dashboard Actions
      "browseBrowseAllServicesAndSpecialists": "🔍 Browse All Services & Specialists",
      "findSpecialistsOnMap": "🗺️ Find Specialists on Map",
      "exploreNearbySpecialists": "Explore nearby specialists with interactive map",
      "reviewsAndProfile": "Reviews & Profile",
      "manageAccountSettings": "Manage your account settings",
      "viewAppointments": "View your appointments and history",
      "updateServicesAndRates": "Update your services and rates",
      
      // Error Messages & Notifications
      "errorOccurred": "An error occurred",
      "tryAgain": "Please try again",
      "successfullyUpdated": "Successfully updated",
      "failedToLoad": "Failed to load",
      "connectionError": "Connection error",
      "invalidInput": "Invalid input",
      "requiredField": "This field is required",
      
      // Homepage & Authentication
      "welcomeBack": "Welcome Back!",
      "whatWouldYouLikeToDoToday": "What would you like to do today? Find services you need or offer your expertise to others.",
      "iNeedServices": "I Need Services",
      "iOfferServices": "I Offer Services",
      
      // Inspirational messages
      "noNeedToDoEverythingYourself": "No need to do everything by yourself anymore - get the right person to help you",
      "buildReputationEnhanceTalents": "Build your reputation and enhance your talents",
      
      // Card titles and content
      "needServices": "Need Services?",
      "wantToOfferServices": "Want to Offer Services?",
      "areYouOverwhelmedWithTasks": "Looking for home cleaning or a handyman?",
      "areYouGoodAtSomething": "Looking for extra or main income?",
      "fromHouseCleaning": "Home cleaning, repairs, furniture assembly - find verified specialists in your city.",
      "turnYourSkills": "Handy with housework or light home repairs? Join and start earning on your own schedule!",
      "verifiedTrustedSpecialists": "Verified & trusted specialists",
      "securePaymentProtection": "Secure payment protection",
      "customerSupport24": "Book a specialist instantly",
      "setYourOwnRates": "Set your own rates & schedule",
      "guaranteedPayments": "Guaranteed payments",
      "buildYourReputation": "Free advertising on the platform",
      
      // Popular services section
      "popularServices": "Popular Services",
      "findSpecialistsServices": "Find specialists for the services you need most",
      "viewAllServices": "View All Services",
      
      // Statistics
      "happyCustomers": "Happy Customers",
      "verifiedSpecialists": "Verified Specialists", 
      "servicesCompleted": "Services Completed",
      "averageRating": "Average Rating",
      
      // Additional translations
      "welcome": "Welcome",
      "trustedBy": "Trusted by 10,000+ users",
      "verifiedSpecialistsbadge": "Verified Specialists",
      
      // Service categories
      "housekeeping": "Housekeeping",
      "handyman": "Handyman", 
      
      // Wallet translations
      "wallet": "Wallet",
      "taxRecords": "Tax Records",
      "overview": "Overview", 
      "income": "Income",
      "spending": "Spending",
      "monthlyBalance": "Monthly Balance",
      "totalIncome": "Total Income",
      "totalSpending": "Total Spending",
      "transactions": "transactions",
      "refresh": "Refresh",
      "exportTax": "Export for Tax",
      "incomeRecords": "Income Records",
      "spendingRecords": "Spending Records", 
      "addIncome": "Add Income",
      "addSpending": "Add Spending",
      "description": "Description",
      "amount": "Amount",
      "date": "Date",
      "category": "Category",
      "add": "Add",
      "cancel": "Cancel",
      
      // Calendar translations
      "calendar": "Calendar",
      "addAppointment": "Add Appointment",
      "clientName": "Client Name",
      "serviceCategory": "Service Category",
      "time": "Time",
      "duration": "Duration",
      "hourlyRate": "Hourly Rate",
      "totalAmount": "Total Amount",
      "monthlyIncomeFromServices": "Monthly Income from Services",
      "monthlySpending": "Monthly Spending",
      "services": "services",
      "expenses": "expenses",
      "previousMonth": "Previous Month",
      "nextMonth": "Next Month",
      "month": "Month",
      "week": "Week", 
      "day": "Day",
      "appointmentsFor": "Appointments for",
      "appointments": "appointments",
      "backToMonthlyView": "Back to Monthly View",
      "previousDay": "Previous Day",
      "nextDay": "Next Day",
      "selectDateToView": "Select Date to View",
      "noAppointmentsThisDay": "No appointments this day",
      "selectDateFromCalendar": "Select a date from calendar",
      "clickOnAnyDateToViewDetails": "Click on any date to view appointment details",
      "edit": "Edit",
      "weekViewComingSoon": "Week view coming soon",
      "dayViewComingSoon": "Day view coming soon",
      
      // Status translations
      "completed": "Completed",
      "pending": "Pending",
      "cancelled": "Cancelled",
      "confirmed": "Confirmed",
      "expired": "Expired",
      "bookingExpired": "Booking Expired",
      "bookingExpiredDesc": "This booking request has expired because the scheduled date/time has passed without confirmation.",
      "findAnotherSpecialist": "Find Another Specialist",
      "noUpcomingBookings": "No upcoming bookings",
      "readyToBookFirstService": "Ready to book your first service?",
      "notWorking": "Day off",
      "clickToEditSchedule": "Click on a day to edit hours",
      "open": "Open",
      "closed": "Closed",
      
      // Footer
      "readyToGetStarted": "Ready to Get Started?",
      "joinThousands": "Join thousands of people who trust SkillSOS for their service needs",
      "connectingSkills": "Connecting skills with needs, safely and reliably.",
      
      // Filters & Search
      "filters": "Filters",
      "resetAll": "Reset All",
      "specialistCategory": "Specialist Category",
      "allCategories": "All Categories",
      "enterLocation": "Enter location...",
      "distanceKm": "Distance: {distance} km",
      "minRating": "Min Rating: {rating}⭐",
      "rateRange": "Rate: €{min} - €{max}/hour",
      "minExperience": "Min Experience: {years} years",
      "selectAvailability": "Select availability",
      "availableDate": "Available Date",
      "availableTime": "Available Time",
      "searchByLocation": "Search by location...",
      "selectCategory": "Select category",
      "rate": "Rate",
      "years": "years",
      "customDateTime": "Custom Date/Time",
      
      // Footer
      "allRightsReserved": "All rights reserved",
      "homeServices": "Home Services",
      "termsConditions": "Terms & Conditions",
      "privacyPolicy": "Privacy Policy", 
      "contact": "Contact",
      "importantNotice": "Important Notice",
      "importantNoticeText": "By using SkillSOS, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.",
      "yourRights": "Your Rights",
      "yourRightsText": "Under GDPR, you have comprehensive rights over your personal data. Contact us at admin@skillsos.bg to exercise these rights.",
      
      // Maria Story - Provider earnings example
      "seeExample": "See Example",
      "seeHowMuchYouCanEarn": "See how much you can earn",
      "seeHowItWorks": "See how it works",
      "startNow": "Start Now",
      "findSpecialist": "Find Specialist",
      "month": "month",
      "total": "total",
      "mariaStory.step1.title": "Maria registers on SkillSOS",
      "mariaStory.step1.desc": "She creates her profile in just 2 minutes",
      "mariaStory.step2.title": "Maria sets up her service",
      "mariaStory.step2.desc": "She chooses Cleaning and sets her hourly rate",
      "mariaStory.step3.title": "Maria receives a request",
      "mariaStory.step3.desc": "A client books her for 4 hours tomorrow",
      "mariaStory.step4.title": "Maria completes the job",
      "mariaStory.step4.desc": "After 24 hours she receives her payment",
      "mariaStory.step4.fee": "(€40 - 5% platform fee - Stripe fees)",
      "mariaStory.step5.title": "Maria's monthly earnings",
      "mariaStory.step5.desc": "Working 5 days/week, 6 hours/day",
      "mariaStory.step5.calculation": "30 clients × €37.60 = net income",
      
      // Ivan Story - Client booking example
      "ivanStory.step1.title": "Ivan needs home cleaning",
      "ivanStory.step1.desc": "His apartment needs a deep clean before guests arrive",
      "ivanStory.step2.title": "Ivan searches on SkillSOS",
      "ivanStory.step2.desc": "He browses verified specialists in his area",
      "ivanStory.step3.title": "Ivan finds Maria",
      "ivanStory.step3.desc": "4.9 stars rating, great reviews, fair price",
      "ivanStory.step4.title": "Ivan books for tomorrow",
      "ivanStory.step4.desc": "3 hours of cleaning, easy online booking",
      "ivanStory.step4.fee": "(5% platform fee for secure payment)",
      "ivanStory.step5.title": "Clean home, happy Ivan!",
      "ivanStory.step5.desc": "Professional service, transparent pricing",
      "ivanStory.step5.savings": "No agency markup, direct contact",
      
      // Currencies
      "EUR": "EUR",
      
      // Calculator Link
      "calculator": "Calculator",
      
      // Services Display
      "servicesOffered": "Services Offered",
      "selectServiceForBooking": "Choose a service when booking",
      "available": "Available",
      "pleaseSelectService": "Please select a service",
      "viewAllServices": "View All Services",
      "bookThisService": "Book This Service",
      
      // Calculator
      "housekeepingTimeCalculator": "Cleaning Services Calculator",
      "getInstantEstimate": "Calculate how long it will take to clean your home.",
      "enterYourDetails": "Enter Your Details",
      "fillInformation": "Fill in the information about your space",
      "homeSize": "Home Size (Square Meters)",
      "homeSizePlaceholder": "e.g., 100",
      "numberOfBathrooms": "Number of Bathrooms",
      "bathroomsPlaceholder": "e.g., 2",
      "additionalServices": "Additional Services",
      "bedLinenChanging": "Bed Linen Changing",
      "ironing": "Ironing",
      "windowCleaning": "Window Cleaning",
      "afterRepairs": "After Repairs (+2 hours)",
      "calculateTime": "Calculate Time",
      "estimatedTime": "Estimated Time",
      "forYourHome": "for your {size}m² home",
      "readyToBook": "Ready to Book?",
      "findVerifiedHousekeepingSpecialists": "Find verified housekeeping specialists on SkillSOS and book your service today!",
      "findHousekeepingSpecialists": "Find Housekeeping Specialists",
      "exploreAllServices": "Explore All Services",
      "fillFormToGetEstimate": "Fill in the form to get your time estimate",
      "howDoesThisWork": "How does this work?",
      "calculatorExplanation": "Our calculator uses industry-standard time estimates to give you an accurate prediction. The actual time may vary based on the specialist's experience and the specific condition of your home.",
      "backToHome": "Back to Home",
      "goToHome": "Go to Home",
      "minutes": "minutes",
      
      // Payment Success Page
      "paymentSuccessTitle": "Payment Successful!",
      "bookingRequestSent": "Your booking request has been sent to the specialist.",
      "waitingForConfirmation": "Waiting for Confirmation",
      "specialistWillConfirm": "The specialist will review and confirm your request. You will receive an email notification.",
      "whatHappensNext": "What happens next?",
      "step1PaymentHeld": "Your payment is held securely",
      "step2SpecialistConfirms": "The specialist will confirm (or decline) the request",
      "step3ServiceCompleted": "After the service is completed, the payment is released",
      "viewMyBookings": "View My Bookings",
      "paymentFailedTitle": "Payment Failed",
      "verifyingPayment": "Verifying payment...",
      
      "connectWithSkilledProviders": "Connect with skilled local service providers",
      
      // New Calculator messaging
      "heroHeadline": "How long does cleaning REALLY take?",
      "heroSubtitle": "No wasting time on viewings and endless conversations. Find out how long it would take to clean Your home or office.",
      "tipSmallHome": "Tip: For a 60m² home with 1 bathroom, standard cleaning takes about 2 hours. If You're quoted significantly more - ask why.",
      "tipMediumHome": "Did You know? An 80m² home with 1 bathroom takes about 2.5 hours to clean. Use this information for Your next quote.",
      "tipLargeHome": "Professionals clean on average 40m² per hour. For larger homes, plan accordingly more time.",
      "notifyMeWhenLaunch": "🔔 Notify me when we launch",
      "sharePrompt": "Was this helpful? Share with friends!",
      "copyLink": "Copy link",
      "linkCopied": "Link copied!",
      "shareText": "Check out this cleaning time calculator - super useful!",
      "seoFooterText": "The SkillSOS calculator helps You plan cleaning time for Your home or office. Stop guessing and compare quotes with confidence. No hidden fees, no surprises.",
      
      // Cancellation Policy
      "setCancellationRefundPolicy": "Set your cancellation and refund policy for clients",
      "chooseYourPolicy": "Choose Your Policy",
      "refundRules": "Refund Rules:",
      "saving": "Saving...",
      "saveCancellationPolicy": "Save Cancellation Policy",
      "lightPolicy": "Light Policy",
      "lightPolicyDesc": "Flexible cancellation with moderate penalties",
      "lightPolicyRule1": "Until 24h before: 100% refund",
      "lightPolicyRule2": "12-24h before: 50% refund",
      "lightPolicyRule3": "Less than 2h: No refund",
      "strictPolicy": "Strict Policy",
      "strictPolicyDesc": "Standard cancellation with time-based penalties",
      "strictPolicyRule1": "48+ hours before: 100% refund",
      "strictPolicyRule2": "24-48h before: 50% refund",
      "strictPolicyRule3": "Less than 24h: No refund",
      "noPenaltiesPolicy": "No Penalties Policy",
      "noPenaltiesPolicyDesc": "Full refund anytime - customer friendly",
      "noPenaltiesPolicyRule1": "Anytime: 100% refund", 
      
      // Payout Information
      "bankAccount": "Bank Account",
      "accountHolder": "Account Holder",
      "accountHolderName": "Account Holder Name",
      "iban": "IBAN",
      "swiftBic": "SWIFT/BIC",
      "swiftBicOptional": "SWIFT/BIC Code (Optional)",
      "bank": "Bank",
      "bankNameOptional": "Bank Name (Optional)",
      "email": "Email",
      "paypalEmail": "PayPal Email",
      "paypal": "PayPal",
      "addPayoutMethod": "Add Payout Method",
      "payoutInformation": "Payout Information",
      "editPayoutMethod": "Edit Payout Method",
      "setupPayoutDescription": "Set up how you want to receive payments for your services",
      "payoutMethodRequired": "Payout Method Required",
      "payoutMethodRequiredDesc": "You must add a payout method before accepting bookings",
      "setUpPayoutMethod": "Set Up Payout Method",
      "payoutMethod": "Payout Method",
      "selectPayoutMethod": "Select payout method",
      "savePayoutMethod": "Save Payout Method",
      "stripeConnectDesc": "Connect with Stripe to receive payments from clients",
      "stripeConnectRequiredDesc": "You need to set up a Stripe account to accept bookings and receive payments.",
      "setupStripeConnect": "Set up payments",
      "stripeSecureNote": "Secure setup via Stripe - we don't store your bank details",
      "stripeConnected": "Stripe is connected",
      "payoutsEnabled": "You can receive payments",
      "payoutsPending": "Waiting for verification...",
      "actionRequired": "Additional actions required",
      "completeStripeSetup": "Please complete your Stripe account setup.",
      "completeSetup": "Complete setup",
      "viewStripeDashboard": "Stripe Dashboard",
      "manage": "Manage",
      "stripeVerificationRequired": "⚠️ Complete Stripe Verification",
      "stripeVerificationDesc": "To accept bookings and payments, you need to complete your bank account verification in Stripe. It usually takes 2-3 minutes.",
      "stripeVerificationNote": "💡 Without completed verification, you cannot accept requests from clients.",
      "stripeVerificationPendingDesc": "You have pending requirements in Stripe. Please complete them to avoid payment interruptions.",
      "stripeVerificationDeadlineNote": "⏰ Complete verification before the deadline to continue accepting payments.",
      "completeVerification": "Complete Verification",
      
      // Help Widget
      "helpTitle": "How can we help?",
      "helpSubtitle": "We respond within 24 hours",
      "needHelp": "Need help?",
      "yourEmail": "Your email",
      "enterEmail": "Enter email",
      "issueCategory": "Category",
      "yourMessage": "Your message",
      "describeIssue": "Describe your issue or question...",
      "attachScreenshot": "Attach screenshot",
      "uploadScreenshot": "Upload screenshot",
      "maxFileSize": "Maximum size: 5MB",
      "helpCategoryPayment": "Payment issue",
      "helpCategoryBooking": "Booking issue",
      "helpCategoryTechnical": "Technical issue",
      "helpCategoryAccount": "Account issue",
      "helpCategoryOther": "Other",
      "helpRequestSent": "Your request has been sent! We'll contact you soon.",
      "helpRequestError": "Error sending request. Please try again.",
      "fillAllFields": "Please fill in all fields",
      "orEmailUs": "Or email us directly at",
      "sending": "Sending...",
      
      "calc_button": "Our fees",
      "calc_title": "Fees & Commissions",
      "calc_how": "How do fees work in SkillSOS?",
      "calc_description": "SkillSOS connects clients with verified specialists. To maintain the platform and ensure service quality, we charge minimal fees only when a transaction takes place.",
      "calc_forClients": "For clients",
      "calc_clientFee": "5% on top of the service price. No hidden fees, no subscription.",
      "calc_forSpecialists": "For specialists",
      "calc_specialistFee": "5% of the service price + payment processing fee via Stripe (1.5% + €0.25 per transaction).",
      "calc_freeRegistration": "Registration is completely free — for both clients and specialists. You owe nothing until a real service takes place.",
      "calc_calculate": "Calculate it yourself",
      "calc_enterPrice": "Enter the service price to see the breakdown:",
      "calc_servicePrice": "Service price (EUR)",
      "calc_clientPays": "Client pays",
      "calc_specialistReceives": "Specialist receives",
      "calc_servicePriceLabel": "Service price",
      "calc_skillsosFee": "SkillSOS fee (5%)",
      "calc_stripeFee": "Stripe fee (1.5% + €0.25)",
      "calc_total": "Total",
      "calc_client": "Client",
      "calc_specialist": "Specialist",
      
      "sos_title": "SOS Matching",
      "sos_subtitle": "Let us find the right specialist for you",
      "sos_description": "Tell us what you need — we'll match you with the best specialist in your area. Fast, free, and personalized.",
      "sos_cta": "Start SOS Matching",
      
      "guarantee_title": "Not happy? We'll refund your money!",
      "guarantee_banner": "Not happy with the service? We'll refund your money!",
      "guarantee_description": "SkillSOS offers 100% money-back guarantee. If you're not satisfied with the service, we'll refund your payment. Our goal is to ensure every booking through SkillSOS is risk-free for you.",
      "guarantee_howItWorks": "How does it work?",
      "guarantee_howText": "If you're not satisfied with the service provided, we'll refund your payment. Our goal is to ensure every booking is risk-free.",
      "guarantee_deadline": "Claim deadline",
      "guarantee_deadlineText": "Claims must be submitted within 12 hours of service completion.",
      "guarantee_covered": "What's covered?",
      "guarantee_noShow": "Specialist didn't show up",
      "guarantee_incomplete": "Work not completed",
      "guarantee_quality": "Unsatisfactory quality",
      "guarantee_different": "Different service than agreed",
      "guarantee_howToClaim": "How to submit a claim?",
      "guarantee_claimText": "Contact us at info@skillsos.bg within 12 hours of the service."
    }
  },
  bg: {
    translation: {
      // Navigation & Header
      "legalAgreements": "Правни условия",
      "agreeTerms": "Съгласен/на съм с Общите условия",
      "acknowledgePrivacy": "Потвърждавам, че съм прочел/а и разбирам Политиката за поверителност",
      "consentMarketing": "Съгласен/на съм да получавам маркетингови съобщения и промоционални оферти по имейл",
      "optional": "По избор",
      "requiredFields": "Задължителни полета. Можете да оттеглите съгласието си по всяко време, като се свържете с",
      "demoData": "Демо данни",
      "skillsos": "СкилSOS",
      "signIn": "Влез",
      "signingIn": "Влизане...",
      "getStarted": "Регистрация",
      "logout": "Изход",
      
      // Forgot Password
      "forgotPassword": "Забравена парола?",
      "resetPassword": "Възстановяване на парола",
      "enterEmailForReset": "Въведете имейла си и ще ви изпратим линк за нова парола",
      "sendResetLink": "Изпрати линк за нова парола",
      "resetEmailSent": "Изпратихме ви имейл с инструкции",
      "checkYourEmail": "Проверете имейла си",
      "resetInstructions": "Изпратихме инструкции за възстановяване на паролата на",
      "backToLogin": "Обратно към вход",
      "createNewPassword": "Създайте нова парола",
      "enterNewPassword": "Въведете новата си парола по-долу",
      "newPassword": "Нова парола",
      "confirmNewPassword": "Потвърдете паролата",
      "saveNewPassword": "Запази новата парола",
      "passwordChanged": "Паролата е променена!",
      "canNowLogin": "Вече можете да влезете с новата си парола.",
      "invalidLink": "Невалиден линк",
      "linkExpiredOrInvalid": "Този линк за възстановяване е невалиден или изтекъл.",
      "passwordResetSuccess": "Паролата е променена успешно!",
      "resetFailed": "Неуспешно възстановяване. Линкът може да е изтекъл.",
      
      "mode": "Режим",
      "switchTo": "Превключи на",
      "client": "Клиент",
      "specialist": "Специалист",
      "becomeSpecialist": "Стани специалист",
      "backToDashboard": "← Назад към таблото",
      "backToServices": "Назад към услугите",
      "cancellationPolicy": "Политика за отмяна",
      "until24hRefund": "До 24ч преди: 100% възстановяване",
      "12to24hRefund": "12-24ч преди: 50% възстановяване",
      "lessThan12hRefund": "По-малко от 12ч: Без възстановяване",
      "paymentMethodRequired": "Необходим е метод на плащане",
      "providerConfirmedAddPayment": "Вашият доставчик потвърди! За да осигурите резервацията си, моля добавете метод на плащане.",
      "actionRequired": "Необходимо действие",
      "securePaymentNow": "Осигури плащане сега",
      // Coming Soon / Wishlist Page
      "comingSoonTitle": "SkillSOS идва скоро!",
      "comingSoonMessage": "Още малко търпение преди да започнем! Искате да сте първите, които ще разберат за нашето стартиране?",
      "whatIsSkillSOS": "Платформа, която свързва клиенти директно със специалисти по почистване и дребни ремонти.",
      "directFromSpecialist": "Директно от специалиста. Без агенции. Без надценки.",
      "benefitPriceTitle": "По-добри цени",
      "benefitPriceDesc": "Без посредници = честна цена",
      "benefitSpeedTitle": "По-бързо",
      "benefitSpeedDesc": "От търсене до резервация за минути",
      "benefitVerifiedTitle": "Верифицирани",
      "benefitVerifiedDesc": "Само проверени специалисти",
      "curiousAboutTime": "Любопитни сте колко време отнема почистването?",
      "tryOurCalculator": "Пробвайте нашия безплатен калкулатор",
      "goToCalculator": "Към калкулатора →",
      "leaveYourEmail": "Оставете ни Вашия имейл.",
      "enterYourEmail": "Въведете Вашия имейл",
      "notifyMe": "Искам да науча първи!",
      "subscribing": "Абонираме Ви...",
      "noSpamPromise": "🔒 Без спам. Само важни новини за стартирането.",
      "thankYou": "Благодарим Ви!",
      "stayTunedMessage": "Очаквайте ни, идваме скоро! 🚀",
      "wellNotifyYou": "Ще Ви уведомим веднага щом стартираме.",
      "backToCalculator": "Обратно към калкулатора",
      "pleaseEnterValidEmail": "Моля, въведете валиден имейл",
      "thankYouForSubscribing": "Благодарим Ви за абонамента!",
      "alreadySubscribed": "Вече сте в нашия списък!",
      "somethingWentWrong": "Нещо се обърка",
      "allRightsReserved": "Всички права запазени.",

      // Landing Page
      "heroTitle": "Свържи се с квалифицирани местни доставчици на услуги",
      "heroDescription": "Намери доказани специалисти за почистване и майсторски услуги със SkillSOS.",
      "findServices": "Намери услуги",
      "readyToExplore": "Какво искаш да правиш днес?",
      "becomeASpecialist": "🏆 Стани специалист",
      "howSkillSOSWorks": "Как работи СкилSOS",
      "popularServices": "Популярни услуги",
      "connectSkillsLine1": "Услуги",
      "connectSkillsLine2": "срещат нужди",
      "marketplaceDescription": "Специалисти ↔ Клиенти. Директен контакт. Почистването и ремонтите са професии - оставете ги на професионалистите!",
      
      // How it works section
      "searchAndDiscover": "Търси и открий",
      "searchDescription": "Разглеждай проверени специалисти в твоя район. Филтрирай по тип услуга, оценки и наличност.",
      "bookAndSchedule": "Резервирай и планирай",
      "bookDescription": "Избери предпочитания от теб час и резервирай веднага. Управлявай срещите си с лекота.",
      "securePayment": "Сигурно плащане",
      "paymentDescription": "Плащай сигурно чрез нашата платформа. Поддръжка за множество методи за плащане включително Stripe и PayPal.",
      "processingPayment": "Обработка на плащането...",
      "amountToHold": "Сума за задържане:",
      "cardNotChargedNow": "Вашата карта НЯМА да бъде таксувана сега.",
      "amountHeldSecurely": "Сумата ще бъде задържана сигурно и ще бъде таксувана едва след завършване на услугата.",
      "verifyingPayment": "Проверка на плащането... Моля, изчакайте.",
      "paymentSecured": "Плащането е осигурено! Вашите средства са задържани безопасно и ще бъдат таксувани едва след завършване на услугата.",
      "redirectingToCheckout": "Пренасочване към сигурно плащане...",
      "securePaymentHold": "Сигурно задържане на плащане",
      "bookingCreatedPleasePayment": "🎉 Резервацията е създадена! Моля, завършете плащането за потвърждение.",
      "waitingForPaymentText": "Очакваме плащането в новия таб... Завършете плащането там и тази страница ще се обнови автоматично.",
      
      // Services
      "housekeeping": "Почистване на дома",
      "handyman": "Майсторски услуги",
      "allServices": "Всички услуги",
      "serviceCategories": "Категории услуги",
      
      // Service mapping for API responses
      "cleaning": "Почистване на дома",
      "handyman": "Майсторски услуги",

      // Authentication
      "createAccount": "Създай профил",
      "fullName": "Пълно име",
      "email": "Имейл",
      "phoneNumber": "Телефонен номер",
      "password": "Парола",
      "confirmPassword": "Потвърди парола",
      "client": "Клиент",
      "specialist": "Специалист",
      "signIn": "Вход",
      "register": "Регистрация",
      "signingIn": "Влизане...",
      "registering": "Регистриране...",
      "emailRequired": "Имейлът е задължителен",
      "emailInvalid": "Моля въведете валиден имейл",
      "passwordRequired": "Паролата е задължителна",
      "passwordMinLength": "Паролата трябва да е поне 6 символа",
      "nameRequired": "Името е задължително",
      "phoneRequired": "Телефонният номер е задължителен",
      "phoneInvalid": "Невалиден телефонен номер",
      "phonePlaceholder": "+359 88 123 4567",
      "phoneHint": "Телефонът ви няма да бъде показван публично",
      "phone": "Телефон",
      "passwordMismatch": "Паролите не съвпадат",
      "termsRequired": "Трябва да приемете общите условия",
      "privacyRequired": "Трябва да приемете политиката за поверителност",
      "demoCredentials": "Демо данни",
      "emailPlaceholder": "вашият@имейл.com",
      "passwordPlaceholder": "Въведете парола",
      "fullNamePlaceholder": "Въведете пълното си име",
      "confirmPasswordPlaceholder": "Потвърдете паролата",
      "accountType": "Тип профил",
      "clientHireServices": "Клиент (наемам услуги)",
      "specialistProvideServices": "Специалист (предлагам услуги)",
      "creatingAccount": "Създавам профил...",
      "continueWithGoogle": "Продължи с Google",
      "quickGoogleSignup": "По-бързо с Google",
      "quickSignupHint": "Регистрирай се за 10 секунди, за да завършиш резервацията",
      
      // Dashboard
      "welcomeBack": "Добре дошъл отново",
      "findAndBookTrusted": "Намери и резервирай доверени доставчици на услуги",
      "manageServicesAndBookings": "Управлявай услугите и резервациите си",
      "searchServices": "🔍 Търси услуги",
      "myBookings": "Моите резервации",
      "yourNotifications": "Вашите известия",
      "recentUpdates": "Последни актуализации",
      "clickToViewDetails": "Кликни за детайли →",
      "adminVerifications": "Админ - Верификации",
      "reviewPendingVerifications": "Прегледай чакащите верификации",
      "confirmedYourBooking": "потвърди вашата резервация!",
      "serviceOn": "Услуга на",
      "bookingCancelled": "Резервацията е отменена",
      "unfortunatelyBookingCancelled": "За съжаление, тази резервация е отменена.",
      "reason": "Причина",
      "foundAnotherProvider": "Намерен е друг доставчик",
      "cancelledBy": "Отменена от",
      "requester": "заявителя",
      "system": "системата",
      "findAnotherSpecialist": "Намери друг специалист",
      "providerConfirmedAnotherBooking": "Доставчикът потвърди друга резервация за този времеви слот",
      "noUpcomingBookings": "Няма предстоящи резервации",
      "readyToBookFirstService": "Готови ли сте да резервирате първата си услуга?",
      "servicesIveRequested": "Услуги, които съм заявил/а",
      "upcoming": "Предстоящи",
      "past": "Минали",
      "Found another provider": "Намерен е друг доставчик",
      "Provider confirmed another booking for this time slot": "Доставчикът потвърди друга резервация за този час",
      "provider": "Доставчик",
      "atRisk": "В риск",
      "awaitingProviderConfirmation": "Очаква потвърждение от доставчика",
      "providerNotifiedMustConfirm": "Доставчикът е уведомен и трябва да потвърди в срок.",
      "payment": "Плащане",
      "willBeSecuredUponConfirmation": "ще бъде осигурено при потвърждение",
      "messageProvider": "Изпрати съобщение на доставчика",
      "cancelBooking": "Отмени резервацията",
      "cancelBookingTitle": "Отмяна на резервация",
      "provider": "Доставчик",
      "date": "Дата",
      "amount": "Сума",
      "reasonForCancellation": "Причина за отмяна",
      "selectAReason": "Изберете причина...",
      "scheduleConflict": "Конфликт в графика",
      "emergency": "Спешност",
      "serviceNoLongerNeeded": "Услугата вече не е необходима",
      "serviceCurrentlyUnavailable": "Услугата временно не е налична",
      "addressAfterPayment": "Адресът ще бъде видим след плащане от клиента",
      "cancelledBookings": "Отменени резервации",
      "yourPayment": "Вашето плащане",
      "ofBooking": "от резервацията",
      "fullCancellationFee": "Пълна такса за отмяна",
      "clientCancelledEarly": "Клиентът отмени рано — получавате пълната такса за отмяна",
      "clientCancelledWithin24h": "Клиентът отмени в рамките на 24ч — частично плащане",
      "clientCancelledLate": "Клиентът отмени късно — получавате пълната сума",
      "cannotProvideService": "Не мога да предоставя услугата",
      "clientRequest": "По молба на клиента",
      "foundAnotherProvider": "Намерен е друг доставчик",
      "other": "Друго",
      "calculatingRefund": "Изчисляване на възстановяването...",
      "fullRefund": "Пълно възстановяване",
      "partialRefund": "Частично възстановяване",
      "noRefund": "Без възстановяване",
      "hoursUntilBooking": "часа до резервацията",
      "policy": "Политика",
      "keepBooking": "Запази резервацията",
      "confirmCancellation": "Потвърди отмяната",
      "remove": "Премахни",
      "bookingArchived": "Резервацията е премахната от списъка",
      "viewYourBookingRequests": "Виж своите заявки за резервации",
      "bookingRequests": "Заявки за резервации",
      "manageIncomingRequests": "Управлявай входящите заявки",
      "reviews": "⭐ Отзиви",
      "settings": "⚙️ Настройки",
      "profile": "Профил",
      "myProfile": "Моят профил",
      "previewMode": "Преглед",
      "previewModeDesc": "Разгледай как ще изглежда профилът ти на доставчик. Регистрирай се, когато си готов да запазиш и да започнеш да получаваш резервации!",
      "registerToSave": "Регистрирай се",
      "manageProfileAndServices": "Управлявай профила и услугите си",
      "myStatistics": "Моята статистика",
      "thisMonth": "този месец",
      "bookings": "Резервации",
      "totalEarned": "Общо спечелено",
      "total": "общо",
      "servicesIOffer": "Услуги, които предлагам",
      "myServiceListing": "Моята обява за услуги",
      "oneListingPerUser": "Можете да имате една активна обява",
      "createListing": "Създай обява",
      "noListingYet": "Все още няма обява",
      "createListingToStart": "Създайте обява, за да започнете да получавате резервации",
      "createYourListing": "Създай своята обява",
      "editYourListing": "Редактирай обявата",
      "oneListingDescription": "Настройте обявата си. Можете да предлагате една категория услуги.",
      "whatServicesDoYouOffer": "Какви услуги предлагате?",
      "selectCategoryFirst": "Първо изберете категория...",
      "describeActivitiesHint": "Изброете конкретните услуги, които можете да предоставите",
      "rateHint": "Средна цена в България: €10-25/час",
      "updateListing": "Обнови обявата",
      "listingUpdated": "Обявата е обновена успешно!",
      "listingCreated": "Обявата е създадена успешно!",
      "savedLocallyNotSynced": "Запазено локално, но не е синхронизирано със сървъра",
      "fillAllRequiredFields": "Моля, попълнете всички задължителни полета",
      "housekeepingServices": "Услуги по домакинство",
      "handymanServices": "Майсторски услуги",
      "perHour": "на час",
      "servicesOffered": "Предлагани услуги",
      "noDescriptionProvided": "Няма предоставено описание",
      "editListing": "Редактирай обявата",
      "pauseListing": "Спри обявата",
      "activateListing": "Активирай обявата",
      "addNewService": "Добави нова услуга",
      "editService": "Редактирай услугата",
      "serviceName": "Име на услугата",
      "serviceNamePlaceholder": "напр., Уроци по изкуство",
      "category": "Категория",
      "selectCategory": "Избери категория",
      "hourlyRate": "Цена на час",
      "minimumServiceFee": "Минимална такса за услугата",
      "optional": "По избор",
      "minimumFeePlaceholder": "напр., 30",
      "minimumFeeHint": "Клиентите ще платят поне тази сума, независимо от продължителността на резервацията",
      "minimumBookingHours": "Минимални часове за резервация",
      "minimumBookingHoursPlaceholder": "минимум 2 часа",
      "minimumBookingHoursHint": "Клиентите трябва да резервират поне толкова часа",
      "description": "Описание",
      "describeYourService": "Опиши услугата си...",
      "cancel": "Откажи",
      "updateService": "Обнови услугата",
      "noServicesYet": "Все още не сте добавили услуги",
      "addYourFirstService": "Добавете първата си услуга",
      "addService": "Добави услуга",
      "edit": "Редактирай",
      "activate": "Активирай",
      "deactivate": "Деактивирай",
      "active": "Активна",
      "inactive": "Неактивна",
      "hour": "ч",
      "hours": "часа",
      "minimum": "минимум",
      "minimumBooking": "Минимална резервация",
      "minimumBookingRequirement": "Изискване за минимална резервация",
      "specialistRequiresMinimum": "Този специалист изисква минимална резервация от",
      "acceptingBookings": "Приема резервации",
      "checkCalendarForAvailability": "Проверете календара при резервация за налични часове",
      "scheduleNotConfigured": "Графикът все още не е конфигуриран",
      "paymentMethods": "Методи на плащане",
      "managePaymentMethodsDesc": "Управлявай запазените методи за бързо резервиране",
      "addCard": "Добави карта",
      "noPaymentMethodsYet": "Все още няма запазени методи на плащане",
      "addYourFirstCard": "Добави първата си карта",
      "viewBookings": "Виж резервациите",
      "editProfile": "Редактирай профила",
      "profileUpdatedSuccessfully": "Профилът е обновен успешно!",
      "name": "Име",
      "newUser": "Нов потребител",
      "nameLastNamePlaceholder": "Име Фамилия",
      "yourName": "Вашето име",
      "enterName": "Въведете име",
      "availability": "Наличност",
      "earnings": "Печалби",
      "myCalendar": "Моят календар",
      "manageProfile": "Управлявай профила",
      "whatServiceDoYouNeed": "От каква услуга имаш нужда днес?",
      "specialistDashboard": "🏆 Табло на специалиста",
      "manageYourServicesAndAppointments": "Управлявай услугите и срещите си.",
      
      // Verification
      "verification": "Верификация",
      "verificationStatus": "Статус на верификация",
      "notSubmitted": "Не е подадено",
      "pending": "В процес на проверка",
      "verifiedBadge": "Верифициран",
      "rejectedBadge": "Отхвърлено",
      "submitVerification": "Подай за верификация",
      "resubmitVerification": "Подай отново верификация",
      "uploadDocuments": "Качи документи",
      "documentType": "Тип документ",
      "selectDocumentType": "Избери тип документ",
      "phoneVerification": "Телефон/Имейл/Снимка",
      "idDocument": "Документ за самоличност",
      "proficiencyDocument": "Документ за квалификация",
      "otherDocument": "Друго",
      "chooseFile": "Избери файл",
      "uploadedFiles": "Качени файлове",
      "noFilesUploaded": "Още няма качени файлове",
      "removeFile": "Премахни",
      "additionalNotes": "Допълнителни бележки",
      "notesPlaceholder": "Добави бележки за администратора, който преглежда документите...",
      "submitForReview": "Подай за преглед",
      "verificationRequirements": "Изисквания за верификация",
      "requirementDescription": "Качи поне 2 документа от следните категории:",
      "phoneEmailPhoto": "Телефон / Имейл / Снимка",
      "idDocuments": "Лична карта, паспорт или шофьорска книжка",
      "proficiencyDocs": "Трудови договори, препоръки, сертификати",
      "otherDocs": "Снимки на извършена работа, съдебна справка, застраховка",
      "verificationPending": "Верификацията ти е в процес на проверка от администратор",
      "verificationApproved": "Профилът ти е верифициран!",
      "verificationRejected": "Верификацията е отхвърлена. Моля, прегледай обратната връзка и подай отново.",
      "adminFeedback": "Обратна връзка от администратора",
      "fileTooLarge": "Файлът е твърде голям. Максималният размер е 5MB",
      "minimumTwoDocuments": "Моля, качи поне 2 документа",
      "verificationSubmitted": "Верификацията е подадена успешно",
      "verificationFailed": "Неуспешно подаване на верификация",
      "viewAndManageAppointments": "Виж и управлявай срещите си",
      "updateServicesAndRates": "Обнови услугите и цените си",
      "trackIncomeAndPayments": "Следи приходите и плащанията си",
      "openFullSpecialistDashboard": "🏢 Отвори пълното табло на специалиста",
      
      // Profile/Settings Forms
      "profileImage": "Снимка на профила",
      "chooseFile": "Избери файл", 
      "noFileSelected": "няма избран файл",
      "uploadSquareImageRecommended": "Качи квадратна снимка (препоръчително). Максимален размер: 5MB.",
      "servicesOffered": "Предлагани услуги",
      "hourlyRate": "Часова ставка",
      "currency": "Валута",
      "minimumServiceFee": "Минимална такса за услуга",
      "yearsOfExperience": "Години опит",
      "bio": "Биография", 
      "minimumServiceFeeDescription": "Минимална такса за услуга: ако е зададена, клиентите ще плащат поне тази сума дори за услуги по-къси от 1 час.",
      
      // Specialists & Booking
      "findYourPerfectSpecialist": "Намери перфектния специалист",
      "browseOurTrustedSpecialists": "Разглеждай нашите доверени специалисти и резервирай услугата, от която имаш нужда.",
      "searchByKeyword": "Търсене по ключова дума (напр. боядисване, монтаж, почистване...)",
      "featuredSpecialists": "Избрани специалисти",
      "loadingSpecialists": "Зареждам специалисти...",
      "specialistNotFound": "Специалистът не е намерен",
      "specialistNotFoundDesc": "Специалистът, когото търсиш, не съществува или е премахнат.",
      "browseAllSpecialists": "Разгледай всички специалисти",
      "viewProfileAndBook": "Виж профила и резервирай",
      "viewProfile": "Виж профила",
      "bookThisSpecialist": "Резервирай този специалист",
      "startingFrom": "Започвайки от",
      "hourly": "/час",
      "yearsExperience": "години опит",
      "noReviews": "Все още няма отзиви. Бъди първият, който резервира и оцени!",
      "reviewsCount": "отзива",
      "bookNowSpecialist": "Резервирай {name} сега",
      "readyToBook": "Готов за резервация?",
      "joinHundredsOfSatisfied": "Присъедини се към стотиците доволни клиенти, които се доверяват на {name}",
      "joinHundredsOfSatisfiedCustomers": "Присъедини се към стотиците доволни клиенти, които се доверяват на",
      "browseMoreSpecialists": "Разгледай повече специалисти",
      "noSpecialistsFound": "Не са намерени специалисти",
      "tryDifferentCategory": "Опитай да избереш друга категория или се върни по-късно.",
      "getStartedToPost": "Започни да предлагаш услуги",
      "joinThousandsSatisfied": "Присъедини се към хиляди доволни клиенти и доставчици на услуги",
      "noSpecialistsAvailable": "В момента няма налични специалисти.",
      "noSpecialistsForCategory": "Няма намерени специалисти за {category}.",
      "viewAllCategories": "Виж всички категории",
      "specialistsFound": "{count} намерен специалист",
      "specialistsFoundPlural": "{count} намерени специалисти",
      "specialistsFoundFor": "{count} намерен специалист за {category}",
      "specialistsFoundPluralFor": "{count} намерени специалисти за {category}",
      
      // Booking Form
      "date": "Дата",
      "time": "Час",
      "selectTime": "Избери час",
      "duration": "Продължителност",
      "durationHours": "Продължителност (часове)",
      "hour": "ч",
      "hours": "часа",
      "serviceAddress": "Адрес за услугата",
      "enterServiceAddress": "Въведи адрес за услугата",
      "specialInstructions": "Специални указания",
      "specialRequirements": "Някакви специални изисквания или бележки",
      "estimatedTotal": "Прогнозна общо:",
      "minimumFeeApplies": "*Прилага се минимална такса от €{fee}",
      "confirmBooking": "Потвърди резервацията",
      "processing": "Обработва се",
      "bookingCreatedSuccessfully": "Резервацията е създадена успешно!",
      "bookingFailed": "Резервацията неуспешна. Моля опитай отново.",
      "pleaseSignInToBook": "Моля влез, за да резервираш услуга",
      "getInstantQuote": "Получи мигновена оферта за твоята услуга",
      "securePaymentSupport": "✓ Сигурно плащане • ✓ Мигновена резервация • ✓ 24/7 поддръжка",
      
      // Booking Management
      "inbox": "Входяща поща",
      "inboxSubtitle": "Управлявай своите разговори и съобщения",
      "newMessage": "Ново съобщение",
      "searchMessages": "Търси съобщения...",
      "noConversations": "Все още няма разговори",
      "selectConversation": "Избери разговор, за да видиш съобщенията",
      "selectConversationHint": "Избери контакт от списъка, за да започнеш чат",
      "typeMessage": "Напиши съобщението си...",
      "typeYourMessage": "Напиши тук съобщението си...",
      "send": "Изпрати",
      "sendMessage": "Изпрати съобщение",
      "messageSentSuccess": "Съобщението е изпратено успешно!",
      "inquiryFrom": "Запитване от",
      "to": "До",
      "from": "От",
      "selectContact": "Избери контакт",
      "active": "Активен",
      "yesterday": "Вчера",
      "more": "Повече",
      "showLess": "Покажи по-малко",
      "termsDescription": "Прочети нашите условия за ползване",
      "privacyDescription": "Научи как защитаваме твоята поверителност и данни",
      "overview": "Преглед",
      "portfolio": "Портфолио",
      "servicesSpecialties": "Услуги и специалности",
      "experienceLevel": "Ниво на опит",
      "expert": "Експерт",
      "serviceArea": "Зона на обслужване",
      "primaryLocation": "Основна локация",
      "serviceRadius": "Радиус на обслужване",
      "within": "в радиус от",
      "radius": "радиус",
      "travelFee": "Такса за пътуване",
      "free": "Безплатно",
      "freeRegistrationBanner": "БЕЗПЛАТНА РЕГИСТРАЦИЯ - Без такси, започни да печелиш сега!",
      "pricingPolicies": "Цени и политики",
      "hourlyRate": "Цена на час",
      "minimumFee": "Минимална такса",
      "cancellationPolicy": "Политика за анулиране",
      "flexible": "Гъвкава",
      "paymentMethods": "Методи на плащане",
      "card": "Карта",
      "cash": "В брой",
      "customerReviews": "Отзиви от клиенти",
      "workPortfolio": "Портфолио",
      "seeExamplesOfWork": "Вижте примери от предишна работа",
      "availabilitySchedule": "Наличност и график",
      "weeklySchedule": "Седмичен график",
      "nextAvailable": "Следваща наличност",
      "nextSlot": "Следващ час",
      "today": "днес",
      "beFirstToReview": "Бъдете първият, който ще остави отзив за този специалист!",
      "selectDateFirst": "Първо изберете дата",
      "noAvailableTimesForDate": "Няма налични часове за тази дата",
      "loadingAvailableTimes": "Зареждане на налични часове...",
      "noReviewsYet": "Все още няма отзиви",
      "helpful": "Полезно",
      "readyToBook": "Готови ли сте?",
      "joinHundredsOfSatisfiedCustomers": "Присъедини се към стотиците доволни клиенти, които се доверяват на",
      "browseMoreSpecialists": "Разгледай повече специалисти",
      "redirectingToAddCard": "Пренасочване за добавяне на карта...",
      "noAvailableSlotsOnDate": "Няма налични часове за тази дата",
      "failedToLoadAvailableTimes": "Неуспешно зареждане на наличните часове",
      "pleaseSelectDate": "Моля, изберете дата",
      "pleaseSelectTime": "Моля, изберете час",
      "pleaseEnterAddress": "Моля, въведете адрес за услугата",
      "providerDoesNotWorkOn": "Специалистът не работи в",
      "sunday": "неделя",
      "monday": "понеделник",
      "tuesday": "вторник",
      "wednesday": "сряда",
      "thursday": "четвъртък",
      "friday": "петък",
      "saturday": "събота",
      "paymentCompletedBookingConfirmed": "Плащането е завършено! Резервацията Ви е потвърдена.",
      "paymentFailedTryAgain": "Плащането не бе успешно. Моля, опитайте отново от Моите резервации.",
      "redirectingToStripe": "Пренасочване към Stripe...",
      "pleaseWait": "Моля, изчакайте...",
      "noPastBookings": "Няма минали резервации",
      "bookingHistoryWillAppearHere": "Историята на резервациите Ви ще се появи тук",
      "pleaseAddPaymentMethodFirst": "Моля, добавете метод за плащане преди да резервирате",
      "addPaymentMethod": "Добави метод за плащане",
      "startConversation": "Започнете разговор",
      "sendFirstMessage": "Изпратете първото си съобщение на този специалист",
      
      // Specialist Profile
      "servicesPeopleWantToBook": "Услуги, които хората искат да резервират от мен",
      "pendingRequests": "Чакащи заявки",
      "noPendingRequests": "Няма чакащи заявки",
      "newBookingRequestsWillAppear": "Новите заявки за резервация ще се появят тук",
      "completedBookings": "Завършени резервации",
      "noCompletedBookings": "Няма завършени резервации",
      "completedBookingsWillAppear": "Завършените резервации ще се появят тук",
      "upcomingConfirmed": "Предстоящи потвърдени",
      "noConfirmedBookings": "Няма потвърдени резервации",
      "acceptedBookingsWillAppear": "Приетите резервации ще се появят тук",
      "notAvailable": "Не е налично",
      "closed": "Затворено",
      "specialist": "специалист",
      "location": "📍 Местоположение",
      "pricing": "💰 Ценообразуване",
      "minimumServiceFee": "Минимална такса за услуга:",
      "servicesAndSpecialties": "Услуги и специалности",
      "customerReviews": "Отзиви от клиенти",
      "reviewsComingSoon": "Отзивите идват скоро...",
      "professionalDescription": "Професионален домашен почистващ с 5+ години опит. Детайлно почистване, налични екологични продукти.",
      
      // Common actions
      "stars": "звезди",
      "star": "звезда",
      "note": "Забележка",
      "weeklyAvailability": "Седмична наличност",
      "editSchedule": "Редактиране на график",
      "scheduleDescription": "Описание на графика",
      "search": "Търси",
      "book": "Резервирай",
      "bookNow": "Резервирай сега",
      "addedToFavorites": "Добавено в любими!",
      "removedFromFavorites": "Премахнато от любими",
      "cancel": "Отказ",
      "save": "Запази",
      "update": "Обнови",
      "delete": "Изтрий",
      "edit": "Редактирай",
      "loading": "Зарежда...",
      "saving": "Записва...",
      "updating": "Обновява...",
      "uploading": "Качва...",
      "submit": "Изпрати",
      "confirm": "Потвърди",
      "view": "Виж",
      "close": "Затвори",
      "next": "Следващ",
      "previous": "Предишен",
      "back": "Назад",
      
      // Enhanced Header & Notifications
      "switchMode": "Превключи",
      "switching": "Превключване...",
      "notifications": "Известия",
      "viewAllNotifications": "Виж всички известия",
      "more": "повече",
      "noNotifications": "Няма нови известия",
      "justNow": "Току-що",
      "ago": "преди",
      "helpCenter": "Помощен център",
      "dashboard": "Табло",
      "back": "← Назад",
      
      // Header Dropdown translations
      "findOnMap": "Намери на картата",
      "browseAllServices": "Разгледай всички услуги",
      "browseServices": "Разгледай услуги", 
      "myDashboard": "Моето табло",
      "mySpecialistDashboard": "Моето специалистично табло",
      "manageAvailability": "Управлявай наличността",
      "viewEarnings": "Виж печалбите",
      "profileSettings": "Настройки на профила",
      "signInAsClient": "Влез като клиент",
      "signInAsSpecialist": "Влез като специалист",
      "learnMore": "Научи повече",
      
      // Footer translations
      "footerDescription": "Свързваме клиенти с доверени специалисти за всички ваши домашни нужди. Безопасно, надеждно и професионално.",
      "services": "Услуги",
      "company": "Компания",
      "support": "Поддръжка",
      "legal": "Правни",
      "aboutUs": "За нас",
      "careers": "Кариери",
      "blog": "Блог",
      "press": "Преса",
      "investors": "Инвеститори",
      "safety": "Безопасност",
      "contact": "Контакт",
      "community": "Общност",
      "accessibility": "Достъпност",
      "termsOfService": "Условия за ползване",
      "cookiePolicy": "Политика за бисквитки",
      "dataPolicy": "Политика за данни",
      "sitemap": "Карта на сайта",
      "allRightsReserved": "Всички права запазени.",
      "availableWorldwide": "Достъпно в световен мащаб",
      
      // Dashboard Actions
      "browseBrowseAllServicesAndSpecialists": "🔍 Разгледай всички услуги и специалисти",
      "findSpecialistsOnMap": "🗺️ Намери специалисти на картата",
      "exploreNearbySpecialists": "Разгледай близки специалисти с интерактивна карта",
      "reviewsAndProfile": "Отзиви и профил",
      "manageAccountSettings": "Управлявай настройките на профила си",
      "viewAppointments": "Виж срещите и историята си",
      "updateServicesAndRates": "Обнови услугите и цените си",
      
      // Error Messages & Notifications
      "errorOccurred": "Възникна грешка",
      "tryAgain": "Моля опитай отново",
      "successfullyUpdated": "Успешно обновено",
      "failedToLoad": "Неуспешно зареждане",
      "connectionError": "Грешка във връзката",
      "invalidInput": "Невалидно въвеждане",
      "requiredField": "Това поле е задължително",
      
      // Homepage & Authentication
      "welcomeBack": "Добре дошъл отново!",
      "whatWouldYouLikeToDoToday": "Какво искаш да правиш днес? Намери услуги, от които имаш нужда, или предложи своите умения на други.",
      "iNeedServices": "Намери чистач или майстор", 
      "iOfferServices": "Регистрирай се като специалист",
      
      // Inspirational messages
      "noNeedToDoEverythingYourself": "Не е нужно да правиш всичко сам вече - намери правилния човек да ти помогне",
      "buildReputationEnhanceTalents": "Подходящо за студенти, като основна или втора работа.",
      
      // Card titles and content
      "needServices": "Имаш нужда от услуги?",
      "wantToOfferServices": "Искаш да предлагаш услуги?",
      "areYouOverwhelmedWithTasks": "Фирми за почистване? По-добре директно чистач или майстор на час!",
      "areYouGoodAtSomething": "Търсиш допълнителен или основен доход?",
      "fromHouseCleaning": "Почистване на дома, дребни ремонти, сглобяване на мебели - намери проверени специалисти в твоя град.",
      "turnYourSkills": "Сръчен си в домакинството или дребните ремонти у дома? Присъедини се и започни да печелиш по собствен график!",
      "verifiedTrustedSpecialists": "Проверени и доверени специалисти",
      "securePaymentProtection": "Сигурна защита на плащанията",
      "customerSupport24": "Резервирай специалист веднага",
      "setYourOwnRates": "Определи собствените си цени и график",
      "guaranteedPayments": "Гарантирани плащания",
      "buildYourReputation": "Безплатна реклама в платформата",
      
      // Popular services section
      "popularServices": "Популярни услуги",
      "findSpecialistsServices": "Намери специалисти за услугите, от които имаш най-голяма нужда",
      "viewAllServices": "Виж всички услуги",
      
      // Statistics / Value Proposition
      "happyCustomers": "Доволни клиенти",
      "verifiedSpecialists": "Проверени специалисти", 
      "servicesCompleted": "Завършени услуги",
      "averageRating": "Средна оценка",
      "directConnection": "Директна връзка",
      "noAgencies": "Без агенции",
      "securePayments": "Сигурни плащания",
      "flexibleSchedule": "Гъвкав график",
      "clientBookingComingSoon": "Резервирането на услуги за клиенти ще бъде достъпно скоро!",
      
      // Auth Modal - Multi-step flow (Bulgarian)
      "welcomeToSkillSOS": "Добре дошли в SkillSOS",
      "welcomeBack": "Добре дошли отново!",
      "createAccount": "Създай профил",
      "enterEmailToContinue": "Въведете имейл, за да продължите",
      "enterEmailToLogin": "Въведете имейл, за да влезете",
      "differentUser": "Друг потребител?",
      "useNewEmail": "Въведете нов имейл",
      "justEnterEmail": "Просто въведете имейла си",
      "emailPlaceholder": "Вашият имейл адрес",
      "continue": "Продължи",
      "checking": "Проверка...",
      "or": "или",
      "continueWithGoogle": "Продължи с Google",
      "quickGoogleSignup": "По-бързо с Google",
      "quickSignupHint": "Регистрирай се за 10 секунди, за да завършиш резервацията",
      "changeEmail": "Промени имейла",
      "passwordPlaceholder": "Вашата парола",
      "signingIn": "Влизане...",
      "signIn": "Вход",
      "noAccount": "Нямате профил?",
      "createOne": "Създайте",
      "fullNamePlaceholder": "Вашето име",
      "createPassword": "Създайте парола",
      "confirmPasswordPlaceholder": "Потвърдете паролата",
      "creatingAccount": "Създаване...",
      "alreadyHaveAccount": "Вече имате профил?",
      "emailRequired": "Моля, въведете имейл",
      "emailInvalid": "Моля, въведете валиден имейл",
      "passwordRequired": "Моля, въведете парола",
      "passwordMinLength": "Паролата трябва да е поне 6 символа",
      "passwordMismatch": "Паролите не съвпадат",
      "step1of2": "Стъпка 1 от 2",
      "step2of2": "Стъпка 2 от 2",
      "agreeToLegal": "Съгласявам се с",
      "agreeToTerms": "Съгласявам се с",
      "agreeToPrivacy": "Съгласявам се с",
      "and": "и",
      "legalRequired": "Моля, приемете условията",
      "nameRequired": "Моля, въведете името си",
      "phoneRequired": "Телефонният номер е задължителен",
      "phoneInvalid": "Невалиден телефонен номер",
      "phonePlaceholder": "+359 88 123 4567",
      "phoneHint": "Телефонът ви няма да бъде показван публично",
      "phone": "Телефон",
      "termsRequired": "Трябва да приемете условията за ползване",
      "privacyRequired": "Трябва да приемете политиката за поверителност",
      "termsAndConditions": "Общи условия",
      "privacyPolicy": "Политика за поверителност",
      "iAcceptThe": "Приемам",
      "iAgreeToReceive": "Съгласявам се да получавам маркетингови съобщения",
      
      // Welcome Modal (post-registration)
      "registrationComplete": "Регистрацията е успешна!",
      "whatBringsYouHere": "Какво Ви води тук?",
      "lookingForSpecialist": "Търся специалист",
      "lookingForSpecialistDesc": "Искам да намеря чистач или майстор",
      "browseSpecialists": "Разгледай специалисти",
      "iOfferServicesShort": "Предлагам услуги",
      "iOfferServicesDesc": "Искам да печеля като специалист",
      "createProfile": "Създай профил",
      
      // Profile Setup Wizard
      "createYourProfile": "Създайте своя профил",
      "profileSetupSubtitle": "Три лесни стъпки, за да започнете да печелите",
      "stepBioLocation": "Профил",
      "stepServices": "Услуги",
      "stepSchedule": "График",
      "tellUsAboutYourself": "Разкажете ни за себе си",
      "helpClientsKnowYou": "Помогнете на клиентите да Ви опознаят",
      "photoUploaded": "Снимката е качена!",
      "photoUploadFailed": "Грешка при качване на снимка",
      "photoRecommended": "Снимката увеличава доверието с 80%",
      "fullName": "Пълно име",
      "enterYourName": "Въведете името си",
      "city": "Град",
      "selectCity": "Изберете град",
      "phone": "Телефон",
      "aboutYou": "За Вас",
      "bioPlaceholder": "Разкажете за своя опит и умения...",
      "nameAndCityRequired": "Моля, въведете име и град",
      "errorSavingProfile": "Грешка при запазване",
      "addServicesAndPricing": "Добавете услуги и определете цените си",
      "yourServices": "Вашите услуги",
      "fillAllServiceFields": "Моля, попълнете всички полета",
      "serviceAdded": "Услугата е добавена!",
      "addAtLeastOneService": "Моля, добавете поне една услуга",
      "errorSavingServices": "Грешка при запазване на услугите",
      "category": "Категория",
      "selectCategory": "Изберете категория",
      "serviceName": "Име на услугата",
      "serviceNamePlaceholder": "напр. Основно почистване",
      "pricePerHour": "Цена/час (€)",
      "duration": "Времетраене",
      "minutes": "мин",
      "setYourSchedule": "Задайте работния си график",
      "scheduleDescription": "Кога сте на разположение за работа?",
      "scheduleCanBeChangedLater": "Можете да промените графика по всяко време",
      "errorSavingSchedule": "Грешка при запазване на графика",
      "skipForNow": "Пропусни засега",
      "saving": "Запазване...",
      "complete": "Завърши",
      "profileSetupComplete": "Профилът е създаден успешно! 🎉",
      "loading": "Зареждане...",
      
      "scheduleSaved": "Графикът е запазен",
      "weeklySchedule": "Седмичен график",
      "paymentMethodsClientDesc": "Добавете карта, за да можете да резервирате и плащате на специалисти",
      "stripeSecurityDisclaimer": "SkillSOS не съхранява данни за карти. Всички плащания се обработват сигурно от Stripe.",
      "payoutProviderDesc": "Добавете банкова сметка, за да получавате плащания от клиенти",
      "notWorking": "Почивен ден",
      "clickToEditSchedule": "Кликнете върху ден, за да редактирате часовете",
      "open": "Отворено",
      "closed": "Затворено",
      "from": "От",
      "to": "До",
      "addYourMainService": "Добавете основната си услуга",
      "yourService": "Вашата услуга",
      "canAddMoreServicesLater": "Можете да добавите още услуги по-късно от профила си",
      "remove": "Премахни",
      "weWillNotifyYou": "Ще Ви уведомим, когато функцията е готова.",
      "understood": "Разбрах",
      "photoUploadedSuccessfully": "Снимката е качена успешно!",
      "photoUploadFailed": "Неуспешно качване на снимка. Моля, опитайте отново.",
      "activitiesOffered": "Какви дейности предлагате?",
      "housekeepingPlaceholder": "напр. редовно почистване, основно почистване, пране, гладене, почистване на прозорци, организиране...",
      "handymanPlaceholder": "напр. сглобяване на мебели, смяна на крушки, монтаж на телевизор, боядисване, монтаж на рафтове, дребни ВиК ремонти...",
      "handymanGuidanceTitle": "💬 Препоръка за майсторски услуги",
      "handymanGuidanceText": "Преди да резервирате, препоръчваме да изпратите съобщение на специалиста с описание на задачата. Така той ще може да Ви каже колко време да резервирате.",
      "sendMessageFirst": "Изпратете съобщение първо",
      "confirmDeleteService": "Сигурни ли сте, че искате да изтриете тази услуга?",
      "serviceDeleted": "Услугата е изтрита",
      "serviceDeletedLocally": "Услугата е изтрита локално, но не успя да се синхронизира със сървъра",
      "selectCategoryFirst": "Първо изберете категория...",
      "describeActivitiesHint": "Опишете конкретните услуги, които можете да предоставите",
      "serviceActivated": "Услугата е активирана",
      "serviceDeactivated": "Услугата е деактивирана",
      "statusSyncError": "Статусът е обновен локално, но не успя да се синхронизира със сървъра",
      "scheduleSavedSuccessfully": "✅ Графикът е запазен успешно!",
      "failedToSaveSchedule": "❌ Неуспешно запазване на графика. Моля, опитайте отново.",
      "rateHintCleaning": "Средна цена в България: €8-20/час",
      "rateHintHandyman": "Средна цена в България: €10-25/час",
      "minimumHours": "Минимални часове",
      "minimumHoursHint": "Минималната продължителност на резервация",
      "minHours": "мин",
      "confirmRemoveCancelledBooking": "Премахване на тази отменена резервация от списъка Ви?",
      "bookingRemoved": "Резервацията е премахната",
      "failedToRemoveBooking": "Неуспешно премахване на резервацията",
      "pleaseLogIn": "Моля, влезте в профила си, за да премахнете резервации",
      "loginSuccessful": "Успешен вход!",
      "loginFailed": "Неуспешен вход",
      "invalidCredentials": "Невалиден имейл или парола",
      "userNotFound": "Потребителят не е намерен",
      "comingSoon": "Очаквайте скоро",
      "bookingComingSoon": "Клиентските резервации ще бъдат налични скоро!",
      "bookingComingSoonDesc": "Добавяме последните щрихи към нашата система за резервации, за да Ви осигурим най-доброто изживяване. Следете за новини!",
      "bookingComingSoonTip": "Междувременно можете да изпратите съобщение директно на специалиста, за да обсъдите вашите нужди.",
      "messageInstead": "Изпрати съобщение",
      "locationNotProvided": "Няма предоставена локация",
      "registrationSuccessful": "Успешна регистрация!",
      "registrationFailed": "Регистрацията е неуспешна",
      "logoutSuccessful": "Успешно излизане",
      "pleaseAcceptTerms": "Моля, приемете общите условия",
      "pleaseAcceptPrivacy": "Моля, приемете политиката за поверителност",
      "tellUsAboutYourself": "Разкажете ни за себе си...",
      "paymentSetupTemporarilyUnavailable": "Настройката на плащания е временно недостъпна. Работим по въпроса! Моля, опитайте отново по-късно.",
      "cityUpdatedSuccessfully": "Градът е актуализиран успешно",
      "failedToSaveLocation": "Неуспешно запазване на локация. Моля, опитайте отново.",
      "serviceArea": "Зона на услугата",
      "selectServiceArea": "Къде предлагате услуги?",
      "serviceAreaHint": "Изберете града, в който предоставяте услуги",
      "selectYourCity": "Изберете вашия град...",
      "locationRequired": "Моля, изберете вашия град/локация",
      "addBioInEditProfile": "Добавете лично представяне в Редактиране на профила",
      "specialistFound": "намерен специалист",
      "noSpecialistsFound": "Не са намерени специалисти",
      "specialistsFoundFor": "намерен специалист за",
      "specialistsFoundPluralFor": "намерени специалисти за",
      "browseByCategory": "Преглед по категория",
      "advancedSearch": "Разширено търсене",
      "allCities": "Всички градове",
      "city": "Град",
      "selectCity": "Изберете град",
      "maxHourlyRate": "Макс. цена на час",
      "useAdvancedFiltersToFindExactly": "Използвайте филтри, за да намерите точно това, което търсите",
      "priceRange": "Ценови диапазон",
      "minimumRating": "Минимален рейтинг",
      "anyRating": "Всякакъв рейтинг",
      "specialistsFound": "намерен специалист",
      "specialistsFoundPlural": "намерени специалисти",
      "for": "за",
      "sortBy": "Сортирай по",
      "random": "Случаен",
      "topRated": "Топ рейтинг",
      "byLocation": "Локация",
      "priceLowToHigh": "Цена ↑",
      "priceHighToLow": "Цена ↓",
      "otherCity": "Друг град...",
      "enterCity": "Въведете град...",

      // Additional translations
      "welcome": "Добре дошли",
      "trustedBy": "Доверие от 10,000+ потребители", 
      "verifiedSpecialistsbadge": "Проверени специалисти",
      
      // Service categories
      "housekeeping": "Домашно почистване",
      "handyman": "Майсторски услуги",
      
      // Wallet translations
      "wallet": "Портфейл",
      "taxRecords": "Данъчни записи",
      "overview": "Преглед",
      "income": "Приходи",
      "spending": "Разходи", 
      "monthlyBalance": "Месечен баланс",
      "totalIncome": "Общи приходи",
      "totalSpending": "Общи разходи",
      "transactions": "транзакции",
      "refresh": "Опресни",
      "exportTax": "Експорт за данъци",
      "incomeRecords": "Записи за приходи",
      "spendingRecords": "Записи за разходи",
      "addIncome": "Добави приход",
      "addSpending": "Добави разход",
      "description": "Описание",
      "amount": "Сума",
      "date": "Дата",
      "category": "Категория",
      "add": "Добави",
      "cancel": "Отказ",
      
      // Calendar translations
      "calendar": "Календар",
      "addAppointment": "Добави среща",
      "clientName": "Име на клиента",
      "serviceCategory": "Категория услуга",
      "time": "Час",
      "duration": "Продължителност",
      "hourlyRate": "Цена на час",
      "totalAmount": "Обща сума",
      "monthlyIncomeFromServices": "Месечни приходи от услуги",
      "monthlySpending": "Месечни разходи",
      "services": "услуги",
      "expenses": "разходи",
      "previousMonth": "Предишен месец",
      "nextMonth": "Следващ месец",
      "month": "Месец",
      "week": "Седмица", 
      "day": "Ден",
      "appointmentsFor": "Срещи за",
      "appointments": "срещи",
      "backToMonthlyView": "Обратно към месечен изглед",
      "previousDay": "Предишен ден",
      "nextDay": "Следващ ден",
      "selectDateToView": "Избери дата за преглед",
      "noAppointmentsThisDay": "Няма срещи този ден",
      "selectDateFromCalendar": "Избери дата от календара",
      "clickOnAnyDateToViewDetails": "Кликни на дата за детайли на срещата",
      "edit": "Редактирай",
      "weekViewComingSoon": "Седмичен изглед скоро",
      "dayViewComingSoon": "Дневен изглед скоро",
      
      // Status translations
      "completed": "Завършен",
      "pending": "Чакащ",
      "cancelled": "Отменена",
      "confirmed": "Потвърден",
      "expired": "Изтекъл",
      "awaitingPayment": "Очаква плащане",
      "providerApprovedPleasePayDesc": "Специалистът прие заявката! Моля, завършете плащането за потвърждение.",
      "amountToPay": "Сума за плащане",
      "includesFee": "вкл. 5% такса",
      "payNow": "Плати сега",
      "willBeSecuredAfterApproval": "ще бъде задържано след одобрение",
      "addressHiddenUntilPayment": "Адресът ще бъде показан след плащане от клиента",
      "bookingExpired": "Резервацията е изтекла",
      "bookingExpiredDesc": "Тази заявка за резервация е изтекла, защото планираната дата/час е минала без потвърждение.",
      
      // Footer
      "readyToGetStarted": "Готов да започнеш?",
      "joinThousands": "Присъедини се към хилядите хора, които се доверяват на SkillSOS за техните нужди от услуги",
      "connectingSkills": "Свързваме умения с нужди, сигурно и надеждно.",
      
      // Location Modal
      "location_modal.title": "Къде можем да ви помогнем?",
      "location_modal.subtitle": "Ще ви покажем най-добрите специалисти наблизо 😊",
      "location_modal.select_placeholder": "Изберете Вашия град...",
      "location_modal.skip": "По-късно",
      "location_modal.continue": "Продължи",
      "location_modal.varna": "Варна",
      "location_modal.sofia": "София",
      "location_modal.plovdiv": "Пловдив",
      "location_modal.burgas": "Бургас",
      "location_modal.other": "Друг град",
      
      // How It Works Section
      "howItWorks": "Как работи",
      "forClients": "За клиенти",
      "forClientsPricesFrom": "За клиенти, цени от",
      "pricesFrom": "цени от",
      "forSpecialists": "За специалисти",
      "forSpecialistsEarn": "За специалисти, печели",
      "earn": "печели",
      "howItWorks_client_step1": "Регистрирай се",
      "howItWorks_client_step1_desc": "Създай акаунт в уебсайта",
      "howItWorks_client_step2": "Разгледай специалисти",
      "howItWorks_client_step2_desc": "Търси по град, вид услуга или рейтинг",
      "howItWorks_client_step3": "Провери наличност",
      "howItWorks_client_step3_desc": "Виж графици и изчисли продължителността с калкулатора",
      "howItWorks_client_step4": "Изпрати заявка",
      "howItWorks_client_step4_desc": "Избери ден, час и продължителност",
      "howItWorks_client_step5": "Получи потвърждение",
      "howItWorks_client_step5_desc": "Провери известията или Моите резервации",
      "howItWorks_client_step6": "Посрещни специалиста",
      "howItWorks_client_step6_desc": "Отпусни се и остави експерта да работи",
      "howItWorks_specialist_step1": "Регистрирай се",
      "howItWorks_specialist_step1_desc": "Създай акаунт като специалист",
      "howItWorks_specialist_step2": "Създай профил",
      "howItWorks_specialist_step2_desc": "Добави данни и метод за изплащане",
      "howItWorks_specialist_step3": "Добави услуги",
      "howItWorks_specialist_step3_desc": "Задай почасова ставка и график",
      "howItWorks_specialist_step4": "Провери заявки",
      "howItWorks_specialist_step4_desc": "Следи известията за нови резервации",
      "howItWorks_specialist_step5": "Приеми и изпълни",
      "howItWorks_specialist_step5_desc": "Потвърди резервации и предостави услугата",
      "howItWorks_specialist_step6": "Получи плащане",
      "howItWorks_specialist_step6_desc": "Парите са при теб до 24 часа",
      
      // Why Join Us Section
      "whyJoinUs": "Защо да се присъединиш?",
      "whyJoinUsSubtitle": "Открий предимствата за клиенти и доставчици на услуги",
      "whyJoinAsClient": "За клиенти",
      "whyJoinAsProvider": "За доставчици",
      "whyClient_fast": "Бързо и удобно",
      "whyClient_fast_desc": "Получи помощ бързо, без забавяния от агенции. Директна връзка с проверени специалисти.",
      "whyClient_affordable": "Достъпни цени",
      "whyClient_affordable_desc": "Без надценки от агенции. Избери доставчик според бюджета си.",
      "whyClient_reviews": "Реални отзиви",
      "whyClient_reviews_desc": "Виж истински отзиви от други клиенти преди да резервираш.",
      "whyClient_transparent": "Прозрачно ценообразуване",
      "whyClient_transparent_desc": "Знай точната цена предварително. Без скрити такси или изненади.",
      "whyProvider_independent": "Работи за себе си",
      "whyProvider_independent_desc": "Бъди сам свой шеф. Приемай или отказвай заявки по желание.",
      "whyProvider_flexible": "Гъвкав график",
      "whyProvider_flexible_desc": "Задай собствен график. Работи когато ти е удобно.",
      "whyProvider_pricing": "Определи своите цени",
      "whyProvider_pricing_desc": "Реши почасовата си ставка. Ти контролираш приходите си.",
      "whyProvider_secure": "Сигурни плащания",
      "whyProvider_secure_desc": "Без преговори с клиенти. Те плащат предварително, ти получаваш парите след извършена услуга.",
      "findSpecialist": "Намери специалист",
      "becomeProvider": "Стани доставчик",
      
      // Filters & Search
      "filters": "Филтри",
      "resetAll": "Нулирай всички",
      "specialistCategory": "Категория специалист",
      "allCategories": "Всички категории",
      "enterLocation": "Въведи местоположение...",
      "distanceKm": "Разстояние: {distance} км",
      "minRating": "Мин. рейтинг: {rating}⭐",
      "rateRange": "Цена: €{min} - €{max}/час",
      "minExperience": "Мин. опит: {years} години",
      "selectAvailability": "Избери наличност",
      "availableDate": "Налична дата",
      "availableTime": "Наличен час",
      "searchByLocation": "Търси по местоположение...",
      "selectCategory": "Избери категория",
      "rate": "Цена",
      "years": "години",
      "customDateTime": "Персонализирана дата/час",
     
      // Weekly Schedule
      "weeklyAvailability": "Седмична наличност",
      "scheduleEditDescription": "Задайте работните си часове за седмицата. Клиентите могат да резервират само през това време.",
    "scheduleDescription": "Вашият текущ седмичен график. Кликнете \"Редактирай график\" за промени.",
      "editSchedule": "Редактирай график",
      "viewMode": "Преглед",
      "editMode": "Редактиране",
      "saveSchedule": "Запази график",
      "notAvailable": "Не е наличен",
      "schedulePresets": "Шаблони",
      "monFri9to5": "Пон-Пет 9-17",
      "open": "Отворено",
      "closed": "Затворено",
      "everyDay": "Всеки ден",
      "clearAll": "Изчисти всичко",
      "startTime": "Начало",
      "endTime": "Край",
      "scheduleSaved": "Графикът е запазен успешно",
      "scheduleError": "Грешка при запазване на графика",
      "monday": "Понеделник",
      "tuesday": "Вторник", 
      "wednesday": "Сряда",
      "thursday": "Четвъртък",
      "friday": "Петък",
      "saturday": "Събота",
      "sunday": "Неделя",

      // Footer
      "allRightsReserved": "Всички права запазени",
      "homeServices": "Домашни услуги",
      "termsConditions": "Общи условия",
      "privacyPolicy": "Политика за поверителност",
      "contact": "Контакт",
      "importantNotice": "Важно съобщение",
      "importantNoticeText": "Използвайки SkillSOS, потвърждавате, че сте прочели, разбрали и се съгласявате да бъдете обвързани от тези Общи условия.",
      "yourRights": "Вашите права",
      "yourRightsText": "Под GDPR имате пълни права върху вашите лични данни. Свържете се с нас на admin@skillsos.bg за да упражните тези права.",
      
      // Enhanced Specialist Profile
      "verified": "Верифициран",
      "new": "Нов",
      "review": "отзив",
      "reviews": "отзива",
      "yearsExp": "Години опит",
      "reviewsCount": "отзива",
      "satisfaction": "Удовлетвореност",
      "responseTime": "Време за отговор",
      "availableToday": "Наличен днес",
      "bookThisSpecialist": "Резервирай този специалист",
      "startingFrom": "Започвайки от",
      "getInstantQuote": "Получи мигновена оферта и резервирай сега",
      "bookNow": "Резервирай сега",
      "bookService": "Резервирай услуга",
      "selectService": "Избери услуга",
      "chooseService": "Избери услуга",
      "selectDate": "Избери дата",
      "selectTime": "Избери час",
      "chooseTime": "Избери час",
      "duration": "Продължителност",
      "hour": "ч",
      "hours": "часа",
      "serviceAddress": "Адрес за услугата",
      "enterServiceAddress": "Въведи адрес за услугата",
      "specialInstructions": "Специални указания",
      "anySpecialRequirements": "Някакви специални изисквания или бележки",
      "pricingSummary": "Обобщение на цените",
      "serviceRate": "Цена на час",
      "totalEstimate": "Обща прогноза",
      "serviceSubtotal": "Стойност на услугата",
      "serviceFee": "Такса за услугата",
      "serviceFeeTooltip": "Таксата покрива сигурно плащане и поддръжка на платформата",
      "totalToPay": "Общо за плащане",
      "paymentMethod": "Метод на плащане",
      "payCash": "Плащане в брой (при среща)",
      "payCard": "Плащане с карта",
      "paymentHoldNote": "Сумата ще бъде задържана сигурно до приключване на услугата. Плащането към специалиста се извършва след вашето потвърждение.",
      "applies": "се прилага",
      "confirmBooking": "Потвърди резервацията",
      
      // Provider earnings
      "earningsBreakdown": "Вашите приходи",
      "serviceAmount": "Стойност на услугата",
      "platformFee": "Такса SkillSOS",
      "stripeFee": "Такса Stripe",
      "youReceive": "Вие получавате",
      "noBookingsYet": "Все още нямате резервации",
      "instructions": "Инструкции",
      "accept": "Приеми",
      "decline": "Откажи",
      "requester": "Заявител",
      "respondBy": "Отговор до",
      "pendingCount": "чакащи",
      "confirmedCount": "потвърдени",
      "loadingRequests": "Зареждане на заявки...",
      "hour": "час",
      "hours": "часа",
      "declineBooking": "Отказ на резервация",
      "declineBookingDescription": "Моля, посочете причина за отказ на тази заявка за резервация.",
      "declineReasonPlaceholder": "напр. Конфликт в графика, извън обслужвания район и др.",
      "confirmDecline": "Потвърди отказа",
      "pleaseProvideDeclineReason": "Моля, посочете причина за отказа",
      "bookingAccepted": "Резервацията е приета! Заявителят е уведомен.",
      "messageRequester": "Съобщение до заявителя",
      "cancelBooking": "Отказ на резервация",
      "reasonForCancellation": "Причина за отказ",
      "selectReason": "Изберете причина...",
      "scheduleConflict": "Конфликт в графика",
      "emergency": "Спешен случай",
      "cannotProvideService": "Не мога да предоставя услугата",
      "clientRequest": "По молба на клиента",
      "other": "Друго",
      "cancellationPolicy": "Политика за отказ",
      "cancellationPolicyText": "Може да се прилагат санкции в зависимост от времето и условията.",
      "date": "Дата",
      "at": "в",
      "amount": "Сума",
      "bookingConfirmedDesc": "Вашата резервация е потвърдена от доставчика.",
      "bookingConfirmed": "Резервацията е потвърдена",
      "payment": "Плащане",
      "heldSecurely": "задържано сигурно",
      "fundsReleasedAfterService": "Средствата ще бъдат освободени на доставчика след завършване на услугата",
      "markCompleted": "Маркирай като завършена",
      "chat": "Чат",
      "chatWith": "Чат с",
      
      "cannotBookYourself": "Не можеш да резервираш себе си",
      "thisIsYourProfile": "Това е твоят профил",
      "goToMyProfile": "Отиди в Моят профил за да управляваш услугите си",
      "notSet": "Не е зададено",
      "processing": "Обработва се",
      "message": "Съобщение",
      "call": "Обади се",
      "securePayment": "Сигурно плащане",
      "instantBooking": "Мигновена резервация",
      "support247": "24/7 поддръжка",
      
      // Hours Calculator
      "hoursCalculator": "Калкулатор за часове",
      "needHelpEstimating": "Не знаеш колко часа да резервираш?",
      "calculatorDescription": "Отговори на няколко въпроса и ще ти препоръчаме оптималната продължителност.",
      "propertySize": "Квадратура на жилището (кв.м)",
      "sqmHint": "100 кв.м ≈ 2.5 часа почистване",
      "numberOfBathrooms": "Брой бани",
      "bathroomHint": "+30 мин за всяка баня",
      "balconySize": "Тераса/Балкон (кв.м)",
      "balconyPlaceholder": "напр., 10",
      "balconyHint": "10 кв.м ≈ +15 мин",
      "customPrice": "Цена от чистач (по избор)",
      "customPricePlaceholder": "напр., 25",
      "customPriceHint": "Въведете цена, която Ви е предложена, за сравнение",
      "customPriceLabel": "Предложена цена от чистач (EUR/час)",
      "priceComparison": "Сравнение на цената",
      "fairPrice": "Честна цена! В рамките на нормалното.",
      "highPrice": "Изглежда високо. Средната ставка е {{avg}} EUR/час за този тип почистване.",
      "lowPrice": "Страхотна оферта! Под средната ставка от {{avg}} EUR/час.",
      "avgRateRange": "Средна пазарна цена: {{min}}-{{max}} EUR/час",
      "totalCostEstimate": "Приблизителна обща цена",
      "basedOnHours": "На база {{hours}} работа",
      "ironingNeeded": "Гладене на дрехи",
      "ironingHint": "+1 час за гладене",
      "frenchWindows": "Френски прозорци",
      "frenchWindowHint": "+30 мин/бр",
      "standardWindows": "Стандартни прозорци",
      "standardWindowHint": "+15 мин/бр",
      "recommendedDuration": "Препоръчителна продължителност:",
      "applyRecommendation": "Приложи",
      "calculatorApplied": "Продължителността е приложена!",
      
      // Review System
      "leaveReview": "Остави отзив",
      "reviewSubmittedSuccess": "Отзивът е изпратен успешно!",
     "howWasProvider": "Как беше {{name}}?",
      "onTimePunctual": "Навреме / Точен",
      "professional": "Професионален",
      "respectful": "Уважителен",
      "goodCommunication": "Добра комуникация",
      "friendlyPleasant": "Приятелски и любезен",
      "additionalCommentsOptional": "Допълнителни коментари (По избор)",
      "shareMoreDetails": "Споделете повече детайли за вашето изживяване...",
      "characters": "символа",
      "reviewVisibilityNote": "Забележка: Вашият отзив ще бъде видим за {{name}} едва след като и двамата сте изпратили отзиви, или след 4 дни.",
      "reviewSubmitFailed": "Неуспешно изпращане на отзив",
      "reviewPromptTitle": "Как беше услугата?",
      "reviewPromptMessage": "Имате завършена услуга, която още не сте оценили. Вашето мнение помага на другите потребители!",
      "moreReviewsPending": "още за оценяване",
      "reviewNow": "Оцени сега",
      "later": "По-късно",
      "withPerson": "с",
      "leaveAReview": "Остави отзив",
      "shareYourExperience": "Сподели опита си с",
      "overallRating": "Обща оценка",
      "required": "*",
      "howWas": "Как беше",
      "additionalComments": "Допълнителни коментари (По избор)",
      "writeYourReview": "Напиши своя отзив (по желание)",
      "tellUsMore": "Разкажи ни повече за опита си...",
      "rateAttributes": "Оцени специфични качества",
      "punctual": "Точност",
      "professional": "Професионализъм",
      "respectful": "Уважителен",
      "communicative": "Добра комуникация",
      "friendly": "Приветлив и приятен",
      "cancel": "Отказ",
      "submitReview": "Изпрати отзив",
      "submitting": "Изпращане...",
      "myReviews": "Моите отзиви",
      "totalReviews": "Общо отзиви",
      "noReviewsYet": "Все още няма отзиви",
      "reviewsWillAppearHere": "Отзивите, които получавате, ще се появят тук",
      "thisUser": "този потребител",
      
      // Maria Story - Provider earnings example
      "seeExample": "Виж пример",
      "seeHowMuchYouCanEarn": "Виж колко можеш да печелиш",
      "seeHowItWorks": "Виж как работи",
      "startNow": "Започни сега",
      "findSpecialist": "Намери специалист",
      "month": "месец",
      "total": "общо",
      "mariaStory.step1.title": "Мария се регистрира в SkillSOS",
      "mariaStory.step1.desc": "Създава профила си само за 2 минути",
      "mariaStory.step2.title": "Мария настройва услугата си",
      "mariaStory.step2.desc": "Избира Почистване и задава часовата си ставка",
      "mariaStory.step3.title": "Мария получава заявка",
      "mariaStory.step3.desc": "Клиент я резервира за 4 часа утре",
      "mariaStory.step4.title": "Мария завършва работата",
      "mariaStory.step4.desc": "След 24 часа получава плащането си",
      "mariaStory.step4.fee": "(€40 - 5% такса на платформата - такси Stripe)",
      "mariaStory.step5.title": "Месечните приходи на Мария",
      "mariaStory.step5.desc": "Работейки 5 дни/седмица по 6 часа/ден",
      "mariaStory.step5.calculation": "30 клиента × €37.60 = нетен доход",
      
      // Ivan Story - Client booking example
      "ivanStory.step1.title": "Иван има нужда от почистване",
      "ivanStory.step1.desc": "Апартаментът му се нуждае от основно почистване преди гости",
      "ivanStory.step2.title": "Иван търси в SkillSOS",
      "ivanStory.step2.desc": "Разглежда проверени специалисти в района си",
      "ivanStory.step3.title": "Иван намира Мария",
      "ivanStory.step3.desc": "4.9 звезди, страхотни отзиви, добра цена",
      "ivanStory.step4.title": "Иван резервира за утре",
      "ivanStory.step4.desc": "3 часа почистване, лесна онлайн резервация",
      "ivanStory.step4.fee": "(5% такса за сигурно плащане)",
      "ivanStory.step5.title": "Чист дом, доволен Иван!",
      "ivanStory.step5.desc": "Професионална услуга, прозрачни цени",
      "ivanStory.step5.savings": "Без надценка от агенция, директен контакт",
      
      // Currencies
      "EUR": "EUR",
      
      // Calculator Link
      "calculator": "Калкулатор",
      
      // Services Display
      "servicesOffered": "Предлагани услуги",
      "selectServiceForBooking": "Изберете услуга при резервация",
      "available": "Налична",
      "pleaseSelectService": "Моля изберете услуга",
      "viewAllServices": "Вижте всички услуги",
      "bookThisService": "Резервирай тази услуга",
      
      // Calculator
      "housekeepingTimeCalculator": "Калкулатор за почистване",
      "getInstantEstimate": "Разберете колко време ще отнеме почистването на Вашия дом.",
      "enterYourDetails": "Въведете Вашите данни",
      "fillInformation": "Попълнете информацията за Вашето пространство",
      "homeSize": "Размер на дома (Квадратни метри)",
      "homeSizePlaceholder": "напр., 100",
      "numberOfBathrooms": "Брой бани",
      "bathroomsPlaceholder": "напр., 2",
      "additionalServices": "Допълнителни услуги",
      "bedLinenChanging": "Смяна на спално бельо (+30 мин)",
      "ironing": "Гладене (+1 час)",
      "windowCleaning": "Почистване на прозорци (+1 час)",
      "afterRepairs": "След ремонт (+2 часа)",
      "calculateTime": "Изчисли времето",
      "estimatedTime": "Прогнозно време",
      "forYourHome": "за Вашия {size}м² дом",
      "readyToBook": "Готови ли сте?",
      "findVerifiedHousekeepingSpecialists": "Намерете верифицирани специалисти по домашно почистване в SkillSOS и резервирайте услугата си днес!",
      "findHousekeepingSpecialists": "Намери специалисти по почистване",
      "exploreAllServices": "Разгледай всички услуги",
      "fillFormToGetEstimate": "Попълнете формата, за да получите прогнозата за време",
      "howDoesThisWork": "Как работи това?",
      "calculatorExplanation": "Нашият калкулатор използва индустриални стандарти за време, за да Ви даде точна прогноза. Действителното време може да варира в зависимост от опита на специалиста и специфичното състояние на Вашия дом.",
      "backToHome": "Обратно към начало",
      "goToHome": "Към началната страница",
      "minutes": "минути",
      
      // Payment Success Page
      "paymentSuccessTitle": "Плащането е успешно!",
      "bookingRequestSent": "Вашата заявка за резервация е изпратена на специалиста.",
      "waitingForConfirmation": "Очаква потвърждение",
      "specialistWillConfirm": "Специалистът ще прегледа и потвърди вашата заявка. Ще получите имейл известие.",
      "whatHappensNext": "Какво следва?",
      "step1PaymentHeld": "Плащането Ви е задържано сигурно",
      "step2SpecialistConfirms": "Специалистът ще потвърди (или откаже) заявката",
      "step3ServiceCompleted": "След извършване на услугата, плащането се освобождава",
      "viewMyBookings": "Виж моите резервации",
      "paymentFailedTitle": "Плащането не успя",
      "verifyingPayment": "Проверка на плащането...",
      
      "connectWithSkilledProviders": "Свържете се с квалифицирани местни доставчици на услуги",
      
      // New Calculator messaging
      "heroHeadline": "Колко време НАИСТИНА отнема почистването?",
      "heroSubtitle": "Без губене на време в огледи и безкрайни разговори. Разберете за колко време биха почистили Вашия дом или офис.",
      "tipSmallHome": "Съвет: За жилище от 60м² с 1 баня, стандартното почистване отнема около 2 часа. Ако Ви предлагат значително повече - питайте защо.",
      "tipMediumHome": "Знаехте ли? Жилище от 80м² с 1 баня се почиства за около 2.5 часа. Използвайте тази информация при следващата си оферта.",
      "tipLargeHome": "Професионалистите почистват средно 40м² на час. За по-големи домове, планирайте съответно повече време.",
      "notifyMeWhenLaunch": "🔔 Известете ме, когато стартираме",
      "sharePrompt": "Полезно ли Ви беше? Споделете с приятели!",
      "copyLink": "Копирай линк",
      "linkCopied": "Линкът е копиран!",
      "copyLinkManually": "Не успяхме да копираме автоматично. Моля, копирайте линка от адресната лента.",
      "shareText": "Вижте този калкулатор за време за почистване - супер полезен!",
      "seoFooterText": "SkillSOS калкулаторът Ви помага да планирате времето за почистване на Вашия дом или офис. Спрете да гадаете и сравнявайте оферти с увереност. Без скрити такси, без изненади.",
      
      // Cancellation Policy
      "setCancellationRefundPolicy": "Задайте политиката си за анулиране и възстановяване за клиенти",
      "chooseYourPolicy": "Изберете Вашата Политика",
      "refundRules": "Правила за Възстановяване:",
      "saving": "Записване...",
      "saveChanges": "Запази промените",
      "saveCancellationPolicy": "Запази Политика за Анулиране",
      "lightPolicy": "Лека Политика",
      "lightPolicyDesc": "Гъвкаво анулиране с умерени наказания",
      "lightPolicyRule1": "До 24ч преди: 100% възстановяване",
      "lightPolicyRule2": "12-24ч преди: 50% възстановяване",
      "lightPolicyRule3": "По-малко от 2ч: Без възстановяване",
      "strictPolicy": "Строга Политика",
      "strictPolicyDesc": "Стандартно анулиране със санкции според времето",
      "strictPolicyRule1": "48+ часа преди: 100% възстановяване",
      "strictPolicyRule2": "24-48ч преди: 50% възстановяване",
      "strictPolicyRule3": "По-малко от 24ч: Без възстановяване",
      "noPenaltiesPolicy": "Политика Без Наказания",
      "noPenaltiesPolicyDesc": "Пълно възстановяване по всяко време - приятелски към клиента",
      "noPenaltiesPolicyRule1": "По всяко време: 100% възстановяване",
      
      // Payout Information
      "bankAccount": "Банкова Сметка",
      "accountHolder": "Титуляр на сметката",
      "accountHolderName": "Име на титуляра на сметката",
      "iban": "IBAN",
      "swiftBic": "SWIFT/BIC",
      "swiftBicOptional": "SWIFT/BIC код (по избор)",
      "bank": "Банка",
      "bankNameOptional": "Име на банка (по избор)",
      "email": "Имейл",
      "paypalEmail": "PayPal имейл",
      "paypal": "PayPal",
      "addPayoutMethod": "Добави метод за плащане",
      "payoutInformation": "Информация за изплащане",
      "editPayoutMethod": "Редактирай метод за изплащане",
      "setupPayoutDescription": "Задайте как искате да получавате плащания за вашите услуги",
      "payoutMethodRequired": "Изисква се метод за изплащане",
      "payoutMethodRequiredDesc": "Трябва да добавите метод за изплащане преди да приемате резервации",
      "setUpPayoutMethod": "Настройка на метод за изплащане",
      "payoutMethod": "Метод за изплащане",
      "selectPayoutMethod": "Изберете метод за изплащане",
      "savePayoutMethod": "Запази метод за изплащане",
      "stripeConnectDesc": "Свържете се със Stripe, за да получавате плащания от клиенти",
      "stripeConnectRequiredDesc": "Трябва да настроите Stripe акаунт, за да можете да приемате резервации и да получавате плащания.",
      "setupStripeConnect": "Настройте плащания",
      "stripeSecureNote": "Сигурна настройка чрез Stripe - не съхраняваме банковите ви данни",
      "stripeConnected": "Stripe е свързан",
      "payoutsEnabled": "Можете да получавате плащания",
      "payoutsPending": "Изчакване на верификация...",
      "actionRequired": "Необходими са допълнителни действия",
      "completeStripeSetup": "Моля, завършете настройката на Stripe акаунта си.",
      "completeSetup": "Завършете настройката",
      "changePayoutMethod": "Промени метод",
      "stripeVerificationRequired": "⚠️ Завършете верификацията в Stripe",
      "stripeVerificationDesc": "За да приемате резервации и плащания, трябва да завършите верификацията на Вашата банкова сметка в Stripe. Обикновено отнема 2-3 минути.",
      "stripeVerificationNote": "💡 Без завършена верификация не можете да приемате заявки от клиенти.",
      "stripeVerificationPendingDesc": "Имате незавършени изисквания в Stripe. Моля, завършете ги, за да избегнете прекъсване на плащанията.",
      "stripeVerificationDeadlineNote": "⏰ Завършете верификацията преди крайния срок, за да продължите да приемате плащания.",
      "completeVerification": "Завърши верификацията",
      
      // Help Widget
      "helpTitle": "Как можем да помогнем?",
      "helpSubtitle": "Отговаряме в рамките на 24 часа",
      "needHelp": "Нужда от помощ?",
      "yourEmail": "Вашият имейл",
      "enterEmail": "Въведете имейл",
      "issueCategory": "Категория",
      "yourMessage": "Вашето съобщение",
      "describeIssue": "Опишете проблема или въпроса си...",
      "attachScreenshot": "Прикачете снимка",
      "uploadScreenshot": "Качете снимка",
      "maxFileSize": "Максимален размер: 5MB",
      "helpCategoryPayment": "Проблем с плащане",
      "helpCategoryBooking": "Проблем с резервация",
      "helpCategoryTechnical": "Технически проблем",
      "helpCategoryAccount": "Проблем с акаунт",
      "helpCategoryOther": "Друго",
      "helpRequestSent": "Вашето запитване е изпратено! Ще се свържем с вас скоро.",
      "helpRequestError": "Грешка при изпращане. Моля, опитайте отново.",
      "fillAllFields": "Моля, попълнете всички полета",
      "orEmailUs": "Или ни пишете директно на",
      "sending": "Изпращане...",
      
      "calc_button": "Нашите такси",
      "calc_title": "Такси и комисиони",
      "calc_how": "Как работят таксите в SkillSOS?",
      "calc_description": "SkillSOS свързва клиенти с проверени специалисти. За да поддържаме платформата и да гарантираме качеството на услугите, начисляваме минимални такси само при извършена транзакция.",
      "calc_forClients": "За клиенти",
      "calc_clientFee": "5% към цената на услугата. Без скрити такси, без абонамент.",
      "calc_forSpecialists": "За специалисти",
      "calc_specialistFee": "5% от цената на услугата + такса за обработка на плащането чрез Stripe (1.5% + €0.25 на транзакция).",
      "calc_freeRegistration": "Регистрацията е напълно безплатна — и за клиенти, и за специалисти. Не дължите нищо, докато не се случи реална услуга.",
      "calc_calculate": "Пресметнете сами",
      "calc_enterPrice": "Въведете цената на услугата, за да видите разбивката:",
      "calc_servicePrice": "Цена на услугата (EUR)",
      "calc_clientPays": "Клиентът плаща",
      "calc_specialistReceives": "Специалистът получава",
      "calc_servicePriceLabel": "Цена на услугата",
      "calc_skillsosFee": "Такса SkillSOS (5%)",
      "calc_stripeFee": "Такса Stripe (1.5% + €0.25)",
      "calc_total": "Общо",
      "calc_client": "Клиент",
      "calc_specialist": "Специалист",
      
      "sos_title": "SOS Мачинг",
      "sos_subtitle": "Нека ти намерим специалист",
      "sos_description": "Кажи ни какво ти трябва — ние ще те свържем с най-подходящия специалист в твоя район. Бързо, безплатно и персонализирано.",
      "sos_cta": "Започни SOS Мачинг",
      
      "guarantee_title": "Не си доволен? Връщаме парите!",
      "guarantee_banner": "Не си доволен от услугата? Връщаме парите!",
      "guarantee_description": "SkillSOS предлага 100% гаранция за връщане на парите. Ако не сте доволни от предоставената услуга, ние ще ви върнем парите. Целта ни е да гарантираме, че всяка резервация през SkillSOS е безрискова за вас.",
      "guarantee_howItWorks": "Как работи?",
      "guarantee_howText": "Ако не сте доволни от предоставената услуга, ние ще ви върнем парите. Целта ни е да гарантираме, че всяка резервация е безрискова.",
      "guarantee_deadline": "Срок за рекламация",
      "guarantee_deadlineText": "Рекламация се подава до 12 часа след приключване на услугата.",
      "guarantee_covered": "Какво е покрито?",
      "guarantee_noShow": "Специалистът не се появи",
      "guarantee_incomplete": "Работата не е завършена",
      "guarantee_quality": "Качеството е незадоволително",
      "guarantee_different": "Различна услуга от договорената",
      "guarantee_howToClaim": "Как да подадете рекламация?",
      "guarantee_claimText": "Свържете се с нас на info@skillsos.bg в рамките на 12 часа след услугата."
    }
  },
  it: {
    translation: {
      // Navigation & Header
      "skillsos": "SkillSOS",
      "signIn": "Accedi",
      "getStarted": "Inizia",
      "logout": "Disconnetti",
      "mode": "Modalità",
      "switchTo": "Passa a",
      "client": "Cliente",
      "specialist": "Specialista",
      "becomeSpecialist": "Diventa specialista",
      "backToDashboard": "← Torna al dashboard",
      "backToServices": "Torna ai servizi",
      "cancellationPolicy": "Politica di cancellazione",
      "until24hRefund": "Fino a 24h prima: 100% rimborso",
      "12to24hRefund": "12-24h prima: 50% rimborso",
      "lessThan12hRefund": "Meno di 12h: Nessun rimborso",
      "paymentMethodRequired": "Metodo di pagamento richiesto",
      "providerConfirmedAddPayment": "Il tuo fornitore ha confermato! Per garantire la prenotazione, aggiungi un metodo di pagamento.",
      "actionRequired": "Azione richiesta",
      "securePaymentNow": "Pagamento sicuro ora",
      // Coming Soon / Wishlist Page
      "comingSoonTitle": "SkillSOS sta arrivando!",
      "comingSoonMessage": "Ancora un po' di pazienza prima di iniziare! Vuoi essere il primo a sapere del nostro lancio?",
      "leaveYourEmail": "Lasciaci la tua email.",
      "enterYourEmail": "Inserisci la tua email",
      "notifyMe": "Voglio sapere per primo!",
      "subscribing": "Iscrizione in corso...",
      "noSpamPromise": "🔒 Niente spam. Solo notizie importanti sul lancio.",
      "thankYou": "Grazie!",
      "stayTunedMessage": "Resta sintonizzato, stiamo arrivando! 🚀",
      "wellNotifyYou": "Ti avviseremo non appena lanceremo.",
      "backToCalculator": "Torna al calcolatore",
      "pleaseEnterValidEmail": "Inserisci un'email valida",
      "thankYouForSubscribing": "Grazie per l'iscrizione!",
      "alreadySubscribed": "Sei già nella nostra lista!",
      "somethingWentWrong": "Qualcosa è andato storto",
      "allRightsReserved": "Tutti i diritti riservati.",

      // Landing Page
      "heroTitle": "Connettiti con fornitori di servizi locali qualificati",
      "heroDescription": "Trova specialisti verificati per pulizie, lavori di manutenzione, cura degli animali e altro. Prenota servizi, gestisci il tuo programma e paga in sicurezza tutto in un posto con SkillSOS.",
      "findServices": "Trova servizi",
      "readyToExplore": "Cosa vorresti fare oggi?",
      "becomeASpecialist": "🏆 Diventa specialista",
      "howSkillSOSWorks": "Come funziona SkillSOS",
      "popularServices": "Servizi popolari",
      "connectSkillsLine1": "Collega Competenze",
      "connectSkillsLine2": "con Bisogni",
      "marketplaceDescription": "Il marketplace di fiducia dove professionisti qualificati incontrano persone che hanno bisogno della loro competenza. Sicuro, affidabile e progettato per tutti.",
      "processingPayment": "Elaborazione del pagamento...",
      "amountToHold": "Importo da trattenere:",
      "cardNotChargedNow": "La tua carta NON verrà addebitata ora.",
      "amountHeldSecurely": "L'importo verrà trattenuto in modo sicuro e addebitato solo dopo il completamento del servizio.",
      "verifyingPayment": "Verifica del pagamento... Attendere prego.",
      "paymentSecured": "Pagamento assicurato! I tuoi fondi sono trattenuti in modo sicuro e verranno addebitati solo dopo il completamento del servizio.",
      "redirectingToCheckout": "Reindirizzamento al pagamento sicuro...",
      "securePaymentHold": "Trattenuta di pagamento sicura",

      // How it works section
      "searchAndDiscover": "Cerca e scopri",
      "searchDescription": "Sfoglia specialisti verificati nella tua zona. Filtra per tipo di servizio, valutazioni e disponibilità.",
      "bookAndSchedule": "Prenota e pianifica",
      "bookDescription": "Scegli il tuo orario preferito e prenota istantaneamente. Gestisci i tuoi appuntamenti con facilità.",
      "securePayment": "Pagamento sicuro",
      "paymentDescription": "Paga in sicurezza attraverso la nostra piattaforma. Supporto per molteplici metodi di pagamento inclusi Stripe e PayPal.",
      
      // Services
      "housekeeping": "Pulizie domestiche",
      "handyman": "Tuttofare",
      "serviceCategories": "Categorie di servizi",
      
      // Service mapping for API responses
      "cleaning": "Pulizie domestiche",
      
      // Authentication
      "createAccount": "Crea account",
      "fullName": "Nome completo",
      "email": "Email",
      "phoneNumber": "Numero di telefono",
      "password": "Password",
      "confirmPassword": "Conferma password",
      "client": "Cliente",
      "specialist": "Specialista",
      "signIn": "Accedi",
      "register": "Registrati",
      "signingIn": "Accedendo...",
      "registering": "Registrando...",
      "emailRequired": "L'email è obbligatoria",
      "emailInvalid": "Inserisci un'email valida",
      "passwordRequired": "La password è obbligatoria",
      "passwordMinLength": "La password deve essere di almeno 6 caratteri",
      "nameRequired": "Il nome è obbligatorio",
      "passwordMismatch": "Le password non corrispondono",
      "termsRequired": "Devi accettare i termini e le condizioni",
      "privacyRequired": "Devi accettare l'informativa sulla privacy",
      "demoCredentials": "Credenziali demo",
      "emailPlaceholder": "tua@email.com",
      "passwordPlaceholder": "Inserisci la password",
      "fullNamePlaceholder": "Inserisci il tuo nome completo",
      "confirmPasswordPlaceholder": "Conferma la password",
      "accountType": "Tipo account",
      "clientHireServices": "Cliente (assumo servizi)",
      "specialistProvideServices": "Specialista (fornisco servizi)",
      "creatingAccount": "Creando account...",
      "continueWithGoogle": "Continua con Google",
      
      // Dashboard
      "welcomeBack": "Bentornato",
      "findAndBookTrusted": "Trova e prenota fornitori di servizi fidati",
      "Found another provider": "Trovato un altro fornitore",
      "Provider confirmed another booking for this time slot": "Il fornitore ha confermato un'altra prenotazione per questo orario",
      "manageServicesAndBookings": "Gestisci i tuoi servizi e prenotazioni",
      "searchServices": "🔍 Cerca servizi",
      "myBookings": "Le mie prenotazioni",
      "noUpcomingBookings": "Nessuna prenotazione in arrivo",
      "bookingCancelled": "Prenotazione annullata",
      "cancelBookingTitle": "Annulla prenotazione",
      "provider": "Fornitore",
      "date": "Data",
      "amount": "Importo",
      "reasonForCancellation": "Motivo della cancellazione",
      "selectAReason": "Seleziona un motivo...",
      "scheduleConflict": "Conflitto di programma",
      "emergency": "Emergenza",
      "serviceNoLongerNeeded": "Servizio non più necessario",
      "other": "Altro",
      "calculatingRefund": "Calcolo del rimborso...",
      "fullRefund": "Rimborso completo",
      "partialRefund": "Rimborso parziale",
      "noRefund": "Nessun rimborso",
      "hoursUntilBooking": "ore fino alla prenotazione",
      "policy": "Politica",
      "keepBooking": "Mantieni prenotazione",
      "confirmCancellation": "Conferma cancellazione",
      "unfortunatelyBookingCancelled": "Purtroppo, questa prenotazione è stata annullata.",
      "reason": "Motivo",
      "foundAnotherProvider": "Trovato un altro fornitore",
      "cancelledBy": "Annullato da",
      "requester": "richiedente",
      "system": "sistema",
      "findAnotherSpecialist": "Trova un altro specialista",
      "providerConfirmedAnotherBooking": "Il fornitore ha confermato un'altra prenotazione per questo orario",
      "readyToBookFirstService": "Pronto a prenotare il tuo primo servizio?",
      "servicesIveRequested": "Servizi che ho richiesto",
      "upcoming": "Prossimi",
      "past": "Passati",
      "provider": "Fornitore",
      "atRisk": "A Rischio",
      "awaitingProviderConfirmation": "In attesa di conferma del fornitore",
      "providerNotifiedMustConfirm": "Il fornitore è stato notificato e deve confermare entro la scadenza.",
      "payment": "Pagamento",
      "willBeSecuredUponConfirmation": "verrà garantito alla conferma",
      "messageProvider": "Invia Messaggio al Fornitore",
      "cancelBooking": "Annulla Prenotazione",
      "remove": "Rimuovi",
      "bookingArchived": "Prenotazione rimossa dall'elenco",
      "viewYourBookingRequests": "Visualizza le tue richieste di prenotazione",
      "bookingRequests": "Richieste di prenotazione",
      "manageIncomingRequests": "Gestisci richieste in arrivo",
      "reviews": "⭐ Recensioni",
      "settings": "⚙️ Impostazioni",
      "profile": "Profilo",
      "myProfile": "Il mio profilo",
      "manageProfileAndServices": "Gestisci il tuo profilo e i tuoi servizi",
      "myStatistics": "Le mie statistiche",
      "thisMonth": "questo mese",
      "bookings": "Prenotazioni",
      "totalEarned": "Totale guadagnato",
      "total": "totale",
      "servicesIOffer": "Servizi che offro",
      "addNewService": "Aggiungi nuovo servizio",
      "editService": "Modifica servizio",
      "serviceName": "Nome del servizio",
      "serviceNamePlaceholder": "es., Lezioni d'arte",
      "category": "Categoria",
      "selectCategory": "Seleziona categoria",
      "hourlyRate": "Tariffa oraria",
      "minimumServiceFee": "Tariffa minima di servizio",
      "optional": "Opzionale",
      "minimumFeePlaceholder": "es., 30",
      "minimumFeeHint": "I clienti pagheranno almeno questo importo, indipendentemente dalla durata della prenotazione",
       "minimumBookingHours": "Ore minime di prenotazione",
       "noServicesYet": "Non hai ancora aggiunto servizi",
      "addYourFirstService": "Aggiungi il tuo primo servizio",
      "minimumBookingHoursPlaceholder": "minimo 2 ore",
      "minimumBookingHoursHint": "I clienti devono prenotare almeno queste ore",
      "hour": "ora",
      "hours": "ore",
      "minimum": "minimo",
      "description": "Descrizione",
      "describeYourService": "Descrivi il tuo servizio...",
      "cancel": "Annulla",
      "updateService": "Aggiorna servizio",
      "addService": "Aggiungi servizio",
      "edit": "Modifica",
      "activate": "Attiva",
      "deactivate": "Disattiva",
      "active": "Attivo",
      "inactive": "Inattivo",
      "paymentMethods": "Metodi di pagamento",
      "managePaymentMethodsDesc": "Gestisci i tuoi metodi di pagamento salvati per prenotazioni rapide",
      "addCard": "Aggiungi carta",
      "noPaymentMethodsYet": "Nessun metodo di pagamento salvato",
      "addYourFirstCard": "Aggiungi la tua prima carta",
      "viewBookings": "Visualizza prenotazioni",
      "editProfile": "Modifica profilo",
      "name": "Nome",
      "yourName": "Il tuo nome",
      "availability": "Disponibilità",
      "earnings": "Guadagni",
      "myCalendar": "Il mio calendario",
      "manageProfile": "Gestisci profilo",
      "whatServiceDoYouNeed": "Di che servizio hai bisogno oggi?",
      "specialistDashboard": "🏆 Dashboard specialista",
      "manageYourServicesAndAppointments": "Gestisci i tuoi servizi e appuntamenti.",
      
      // Verification
      "verification": "Verifica",
      "verificationStatus": "Stato di verifica",
      "notSubmitted": "Non inviato",
      "pending": "In revisione",
      "verifiedBadge": "Verificato",
      "rejectedBadge": "Rifiutato",
      "submitVerification": "Invia per verifica",
      "resubmitVerification": "Invia nuovamente verifica",
      "uploadDocuments": "Carica documenti",
      "documentType": "Tipo di documento",
      "selectDocumentType": "Seleziona tipo di documento",
      "phoneVerification": "Telefono/Email/Foto",
      "idDocument": "Documento d'identità",
      "proficiencyDocument": "Documento di competenza",
      "otherDocument": "Altro",
      "chooseFile": "Scegli file",
      "uploadedFiles": "File caricati",
      "noFilesUploaded": "Nessun file caricato ancora",
      "removeFile": "Rimuovi",
      "additionalNotes": "Note aggiuntive",
      "notesPlaceholder": "Aggiungi note per l'amministratore che revisiona i tuoi documenti...",
      "submitForReview": "Invia per revisione",
      "verificationRequirements": "Requisiti di verifica",
      "requirementDescription": "Carica almeno 2 documenti dalle seguenti categorie:",
      "phoneEmailPhoto": "Telefono / Email / Foto",
      "idDocuments": "Carta d'identità, passaporto o patente",
      "proficiencyDocs": "Contratti di lavoro, referenze, certificati",
      "otherDocs": "Foto di lavori svolti, certificato penale, assicurazione",
      "verificationPending": "La tua verifica è in attesa di revisione da parte dell'amministratore",
      "verificationApproved": "Il tuo profilo è verificato!",
      "verificationRejected": "Verifica rifiutata. Rivedi il feedback e invia nuovamente.",
      "adminFeedback": "Feedback dell'amministratore",
      "fileTooLarge": "File troppo grande. La dimensione massima è 5MB",
      "minimumTwoDocuments": "Carica almeno 2 documenti",
      "verificationSubmitted": "Verifica inviata con successo",
      "verificationFailed": "Invio verifica fallito",
      "viewAndManageAppointments": "Visualizza e gestisci i tuoi appuntamenti",
      "updateServicesAndRates": "Aggiorna i tuoi servizi e le tariffe",
      "trackIncomeAndPayments": "Monitora le tue entrate e i pagamenti", 
      "openFullSpecialistDashboard": "🏢 Apri dashboard specialista completa",
      
      // Profile/Settings Forms
      "profileImage": "Immagine profilo",
      "chooseFile": "Scegli file",
      "noFileSelected": "nessun file selezionato",
      "uploadSquareImageRecommended": "Carica un'immagine quadrata (consigliata). Dimensione massima: 5MB.",
      "servicesOffered": "Servizi offerti",
      "hourlyRate": "Tariffa oraria",
      "currency": "Valuta",
      "minimumServiceFee": "Tariffa minima del servizio",
      "yearsOfExperience": "Anni di esperienza", 
      "bio": "Biografia",
      "minimumServiceFeeDescription": "Tariffa minima del servizio: se impostata, i clienti pagheranno almeno questo importo anche per servizi più brevi di 1 ora.",
      
      // Specialists & Booking
      "findYourPerfectSpecialist": "Trova il tuo specialista perfetto",
      "browseOurTrustedSpecialists": "Sfoglia i nostri specialisti fidati e prenota il servizio di cui hai bisogno.",
      "featuredSpecialists": "Specialisti in evidenza",
      "loadingSpecialists": "Caricamento specialisti...",
      "specialistNotFound": "Specialista non trovato",
      "specialistNotFoundDesc": "Lo specialista che stai cercando non esiste o è stato rimosso.",
      "browseAllSpecialists": "Sfoglia tutti gli specialisti",
      "viewProfileAndBook": "Visualizza profilo e prenota",
      "bookThisSpecialist": "Prenota questo specialista",
      "startingFrom": "A partire da",
      "hourly": "/ora",
      "yearsExperience": "anni di esperienza",
      "noReviews": "Ancora nessuna recensione. Sii il primo a prenotare e recensire!",
      "reviewsCount": "recensioni",
      "bookNowSpecialist": "Prenota {name} ora",
      "readyToBook": "Pronto a prenotare?",
      "joinHundredsOfSatisfied": "Unisciti a centinaia di clienti soddisfatti che si sono fidati di {name}",
      "joinHundredsOfSatisfiedCustomers": "Unisciti a centinaia di clienti soddisfatti che si sono fidati di",
      "browseMoreSpecialists": "Sfoglia Altri Specialisti",
      "noSpecialistsFound": "Nessuno specialista trovato",
      "noSpecialistsAvailable": "Al momento non ci sono specialisti disponibili.",
      "noSpecialistsForCategory": "Nessuno specialista trovato per {category}.",
      "viewAllCategories": "Visualizza tutte le categorie",
      "specialistsFound": "{count} specialista trovato",
      "specialistsFoundPlural": "{count} specialisti trovati",
      "specialistsFoundFor": "{count} specialista trovato per {category}",
      "specialistsFoundPluralFor": "{count} specialisti trovati per {category}",
      
      // Booking Form
      "date": "Data",
      "time": "Ora",
      "selectTime": "Seleziona ora",
      "duration": "Durata",
      "durationHours": "Durata (ore)",
      "hour": "ora",
      "hours": "ore",
      "serviceAddress": "Indirizzo del servizio",
      "enterServiceAddress": "Inserisci indirizzo del servizio",
      "specialInstructions": "Istruzioni speciali",
      "specialRequirements": "Eventuali requisiti speciali o note",
      "estimatedTotal": "Totale stimato:",
      "minimumFeeApplies": "*Si applica una tariffa minima di €{fee}",
      "confirmBooking": "Conferma prenotazione",
      "cannotBookYourself": "Non puoi prenotare te stesso",
      "thisIsYourProfile": "Questo è il tuo profilo",
      "goToMyProfile": "Vai a Il mio profilo per gestire i tuoi servizi",
      "processing": "Elaborazione",
      "bookingCreatedSuccessfully": "Prenotazione creata con successo!",
      "bookingFailed": "Prenotazione fallita. Riprova.",
      "pleaseSignInToBook": "Accedi per prenotare un servizio",
      "getInstantQuote": "Ottieni un preventivo istantaneo per il tuo servizio",
      "securePaymentSupport": "✓ Pagamento sicuro • ✓ Prenotazione istantanea • ✓ Supporto 24/7",
      "overview": "Panoramica",
      "portfolio": "Portfolio",
      "servicesSpecialties": "Servizi e specialità",
      "experienceLevel": "Livello di esperienza",
      "expert": "Esperto",
      "serviceArea": "Area di servizio",
      "primaryLocation": "Posizione principale",
      "serviceRadius": "Raggio di servizio",
      "within": "entro",
      "radius": "raggio",
      "travelFee": "Tariffa di viaggio",
      "free": "Gratuito",
      "pricingPolicies": "Prezzi e politiche",
      "hourlyRate": "Tariffa oraria",
      "minimumFee": "Tariffa minima",
      "cancellationPolicy": "Politica di cancellazione",
      "flexible": "Flessibile",
      "paymentMethods": "Metodi di pagamento",
      "card": "Carta",
      "cash": "Contanti",
      "customerReviews": "Recensioni clienti",
      
      // Inbox & Messaging
      "inbox": "Posta in arrivo",
      "inboxSubtitle": "Gestisci le tue conversazioni e messaggi",
      "newMessage": "Nuovo Messaggio",
      "searchMessages": "Cerca messaggi...",
      "noConversations": "Nessuna conversazione ancora",
      "selectConversation": "Seleziona una conversazione per visualizzare i messaggi",
      "selectConversationHint": "Scegli un contatto dall'elenco per iniziare a chattare",
      "typeMessage": "Scrivi il tuo messaggio...",
      "typeYourMessage": "Scrivi qui il tuo messaggio...",
      "send": "Invia",
      "sendMessage": "Invia Messaggio",
      "to": "A",
      "selectContact": "Seleziona un contatto",
      "active": "Attivo",
      "yesterday": "Ieri",
      "more": "Più",
      "showLess": "Mostra meno",
      "termsDescription": "Leggi i nostri termini di servizio e condizioni",
      "privacyDescription": "Scopri come proteggiamo la tua privacy e i tuoi dati",
      
      // Specialist Profile
      "location": "📍 Posizione",
      "pricing": "💰 Prezzi",
      "minimumServiceFee": "Tariffa minima del servizio:",
      "servicesAndSpecialties": "Servizi e specialità",
      "customerReviews": "Recensioni clienti",
      "reviewsComingSoon": "Recensioni in arrivo...",
      "professionalDescription": "Addetto alle pulizie domestiche professionale con oltre 5 anni di esperienza. Pulizie dettagliate, prodotti ecologici disponibili.",
      
      // Common actions
      "search": "Cerca",
      "book": "Prenota",
      "bookNow": "Prenota ora",
      "cancel": "Annulla",
      "save": "Salva",
      "update": "Aggiorna",
      "delete": "Elimina",
      "edit": "Modifica",
      "loading": "Caricamento...",
      "saving": "Salvando...",
      "updating": "Aggiornando...",
      "uploading": "Caricamento...",
      "submit": "Invia",
      "confirm": "Conferma",
      "view": "Visualizza",
      "close": "Chiudi",
      "comingSoon": "Prossimamente",
      "bookingComingSoon": "La prenotazione clienti sarà disponibile a breve!",
      "bookingComingSoonDesc": "Stiamo ultimando il nostro sistema di prenotazione per garantirti la migliore esperienza. Resta sintonizzato!",
      "bookingComingSoonTip": "Nel frattempo, sentiti libero di inviare un messaggio direttamente allo specialista per discutere delle tue esigenze.",
      "messageInstead": "Contatta lo specialista",
      "next": "Successivo",
      "previous": "Precedente",
      "back": "Indietro",
      
      // Why Join Us Section
      "whyJoinUs": "Perché Unirti a Noi?",
      "whyJoinUsSubtitle": "Scopri i vantaggi per clienti e fornitori di servizi",
      "whyJoinAsClient": "Per i Clienti",
      "whyJoinAsProvider": "Per i Fornitori",
      "whyClient_fast": "Veloce e Comodo",
      "whyClient_fast_desc": "Ottieni aiuto rapidamente senza ritardi delle agenzie. Connessione diretta con specialisti verificati.",
      "whyClient_affordable": "Prezzi Accessibili",
      "whyClient_affordable_desc": "Nessun ricarico delle agenzie. Scegli un fornitore adatto al tuo budget.",
      "whyClient_reviews": "Recensioni Verificate",
      "whyClient_reviews_desc": "Leggi recensioni reali di altri clienti prima di prenotare.",
      "whyClient_transparent": "Prezzi Trasparenti",
      "whyClient_transparent_desc": "Conosci il costo esatto in anticipo. Nessuna commissione nascosta.",
      "whyProvider_independent": "Lavora per Te Stesso",
      "whyProvider_independent_desc": "Sii il capo di te stesso. Accetta o rifiuta richieste come preferisci.",
      "whyProvider_flexible": "Orari Flessibili",
      "whyProvider_flexible_desc": "Imposta il tuo programma. Lavora quando ti fa comodo.",
      "whyProvider_pricing": "Stabilisci le Tue Tariffe",
      "whyProvider_pricing_desc": "Decidi la tua tariffa oraria. Controlli i tuoi guadagni.",
      "whyProvider_secure": "Pagamenti Sicuri",
      "whyProvider_secure_desc": "Nessuna trattativa con i clienti. Loro pagano in anticipo, tu ricevi dopo il lavoro svolto.",
      "findSpecialist": "Trova uno Specialista",
      "becomeProvider": "Diventa Fornitore",
      
      // Enhanced Header & Notifications
      "switchMode": "Cambia",
      "switching": "Cambiando...",
      "notifications": "Notifiche",
      "viewAllNotifications": "Vedi Tutte le Notifiche",
      "more": "più",
      "noNotifications": "Nessuna nuova notifica",
      "justNow": "Proprio ora",
      "ago": "fa",
      "helpCenter": "Centro Assistenza",
      "dashboard": "Dashboard",
      
      // Header Dropdown translations
      "findOnMap": "Trova sulla Mappa",
      "browseAllServices": "Sfoglia Tutti i Servizi",
      "browseServices": "Sfoglia Servizi", 
      "myDashboard": "La Mia Dashboard",
      "mySpecialistDashboard": "La Mia Dashboard Specialista",
      "manageAvailability": "Gestisci Disponibilità",
      "viewEarnings": "Visualizza Guadagni",
      "profileSettings": "Impostazioni Profilo",
      "signInAsClient": "Accedi come Cliente",
      "signInAsSpecialist": "Accedi come Specialista",
      "learnMore": "Scopri di Più",
      
      // Footer translations
      "footerDescription": "Colleghiamo i clienti con specialisti fidati per tutte le vostre esigenze domestiche. Sicuro, affidabile e professionale.",
      "services": "Servizi",
      "company": "Azienda",
      "support": "Supporto",
      "legal": "Legale",
      "aboutUs": "Chi siamo",
      "careers": "Carriere",
      "blog": "Blog",
      "press": "Stampa",
      "investors": "Investitori",
      "safety": "Sicurezza",
      "contact": "Contatto",
      "community": "Comunità",
      "accessibility": "Accessibilità",
      "termsOfService": "Termini di servizio",
      "cookiePolicy": "Politica sui cookie",
      "dataPolicy": "Politica sui dati",
      "sitemap": "Mappa del sito",
      "allRightsReserved": "Tutti i diritti riservati.",
      "availableWorldwide": "Disponibile in tutto il mondo",
      
      // Dashboard Actions
      "browseBrowseAllServicesAndSpecialists": "🔍 Sfoglia tutti i servizi e specialisti",
      "findSpecialistsOnMap": "🗺️ Trova specialisti sulla mappa",
      "exploreNearbySpecialists": "Esplora specialisti vicini con mappa interattiva",
      "reviewsAndProfile": "Recensioni e profilo",
      "manageAccountSettings": "Gestisci le impostazioni del tuo account",
      "viewAppointments": "Visualizza i tuoi appuntamenti e la cronologia",
      "updateServicesAndRates": "Aggiorna i tuoi servizi e le tariffe",
      
      // Error Messages & Notifications
      "errorOccurred": "Si è verificato un errore",
      "tryAgain": "Riprova",
      "successfullyUpdated": "Aggiornato con successo",
      "failedToLoad": "Caricamento fallito",
      "connectionError": "Errore di connessione",
      "invalidInput": "Input non valido",
      "requiredField": "Questo campo è obbligatorio",
      
      // Homepage & Authentication
      "welcomeBack": "Bentornato!",
      "whatWouldYouLikeToDoToday": "Cosa vorresti fare oggi? Trova i servizi di cui hai bisogno o offri la tua competenza ad altri.",
      "iNeedServices": "Cerco servizi",
      "iOfferServices": "Offro servizi",
      
      // Inspirational messages
      "noNeedToDoEverythingYourself": "Non hai più bisogno di fare tutto da solo - trova la persona giusta per aiutarti",
      "buildReputationEnhanceTalents": "Costruisci la tua reputazione e migliora i tuoi talenti",
      
      // Card titles and content
      "needServices": "Hai bisogno di servizi?",
      "wantToOfferServices": "Vuoi offrire servizi?",
      "areYouOverwhelmedWithTasks": "Sei sopraffatto dalle attività?",
      "areYouGoodAtSomething": "Sei bravo in qualcosa?",
      "fromHouseCleaning": "Dalle pulizie domestiche ai lavori di riparazione - trova specialisti verificati che possano aiutarti.",
      "turnYourSkills": "Trasforma le tue competenze in guadagni! Unisciti a migliaia di specialisti che guadagnano facendo ciò che amano, secondo i loro orari.",
      "verifiedTrustedSpecialists": "Specialisti verificati e fidati",
      "securePaymentProtection": "Protezione sicura dei pagamenti",
      "customerSupport24": "Supporto clienti 24/7",
      "setYourOwnRates": "Imposta le tue tariffe e orari",
      "guaranteedPayments": "Pagamenti garantiti",
      "buildYourReputation": "Costruisci la tua reputazione",
      
      // Popular services section
      "popularServices": "Servizi Popolari",
      "findSpecialistsServices": "Trova specialisti per i servizi di cui hai più bisogno",
      "viewAllServices": "Vedi Tutti i Servizi",
      
      // Statistics
      "happyCustomers": "Clienti Soddisfatti",
      "verifiedSpecialists": "Specialisti Verificati", 
      "servicesCompleted": "Servizi Completati",
      "averageRating": "Valutazione Media",
      
      // Additional translations
      "welcome": "Benvenuto",
      "trustedBy": "Fidato da 10.000+ utenti",
      "verifiedSpecialistsbadge": "Specialisti Verificati",
      
      // Service categories  
      "housekeeping": "Pulizie Domestiche",
      "handyman": "Tuttofare",
      
      // Wallet translations
      "wallet": "Portafoglio",
      "taxRecords": "Registri Fiscali",
      "overview": "Panoramica",
      "income": "Entrate",
      "spending": "Spese",
      "monthlyBalance": "Saldo Mensile",
      "totalIncome": "Entrate Totali", 
      "totalSpending": "Spese Totali",
      "transactions": "transazioni",
      "refresh": "Aggiorna",
      "exportTax": "Esporta per Tasse",
      "incomeRecords": "Registri Entrate",
      "spendingRecords": "Registri Spese",
      "addIncome": "Aggiungi Entrata",
      "addSpending": "Aggiungi Spesa",
      "description": "Descrizione",
      "amount": "Importo",
      "date": "Data", 
      "category": "Categoria",
      "add": "Aggiungi",
      "cancel": "Annulla",
      
      // Booking Management
      "servicesPeopleWantToBook": "Servizi che le persone vogliono prenotare da me",
      "pendingRequests": "Richieste in attesa",
      "noPendingRequests": "Nessuna richiesta in attesa",
      "newBookingRequestsWillAppear": "Le nuove richieste di prenotazione appariranno qui",
      "upcomingConfirmed": "Prossime confermate",
      "noConfirmedBookings": "Nessuna prenotazione confermata",
      "acceptedBookingsWillAppear": "Le prenotazioni accettate appariranno qui",
      "completedBookings": "Prenotazioni completate",
      "noCompletedBookings": "Nessuna prenotazione completata",
      "completedBookingsWillAppear": "Le prenotazioni completate appariranno qui",
      "calendar": "Calendario",
      "addAppointment": "Aggiungi Appuntamento",
      "clientName": "Nome Cliente",
      "serviceCategory": "Categoria Servizio",
      "time": "Ora",
      "duration": "Durata",
      "hourlyRate": "Tariffa Oraria",
      "totalAmount": "Importo Totale",
      "weeklyAvailability": "Disponibilità Settimanale",
      "editSchedule": "Modifica Orario",
      "scheduleDescription": "Descrizione Orario",
      "monthlyIncomeFromServices": "Entrate Mensili dai Servizi",
      "monthlySpending": "Spese Mensili",
      "services": "servizi",
      "expenses": "spese",
      "previousMonth": "Mese Precedente",
      "nextMonth": "Mese Successivo",
      "month": "Mese",
      "week": "Settimana", 
      "day": "Giorno",
      "appointmentsFor": "Appuntamenti per",
      "appointments": "appuntamenti",
      "backToMonthlyView": "Torna alla Vista Mensile",
      "monday": "Lunedì",
      "tuesday": "Martedì",
      "wednesday": "Mercoledì",
      "thursday": "Giovedì",
      "friday": "Venerdì",
      "saturday": "Sabato",
      "sunday": "Domenica",
      "notAvailable": "Non disponibile",
      "closed": "Chiuso",
      "specialist": "specialista",  
      "previousDay": "Giorno Precedente",
      "nextDay": "Giorno Successivo",
      "selectDateToView": "Seleziona Data da Visualizzare",
      "noAppointmentsThisDay": "Nessun appuntamento questo giorno",
      "selectDateFromCalendar": "Seleziona una data dal calendario",
      "clickOnAnyDateToViewDetails": "Clicca su una data per vedere i dettagli",
      "edit": "Modifica",
      "weekViewComingSoon": "Vista settimanale in arrivo",
      "dayViewComingSoon": "Vista giornaliera in arrivo",
      
      // Status translations
      "completed": "Completato",
      "pending": "In Attesa",
      "cancelled": "Annullato",
      "confirmed": "Confermato",
      
      // Footer
      "readyToGetStarted": "Pronto per iniziare?",
      "joinThousands": "Unisciti a migliaia di persone che si fidano di SkillSOS per le loro esigenze di servizio",
      "connectingSkills": "Collegando competenze con bisogni, in modo sicuro e affidabile.",
      
      // Filters & Search
      "filters": "Filtri",
      "resetAll": "Reimposta tutto",
      "specialistCategory": "Categoria specialista",
      "allCategories": "Tutte le categorie",
      "enterLocation": "Inserisci posizione...",
      "distanceKm": "Distanza: {distance} km",
      "minRating": "Valutazione min: {rating}⭐",
      "rateRange": "Tariffa: €{min} - €{max}/ora",
      "minExperience": "Esperienza min: {years} anni",
      "selectAvailability": "Seleziona disponibilità",
      "availableDate": "Data disponibile",
      "availableTime": "Orario disponibile",
      "searchByLocation": "Cerca per posizione...",
      "selectCategory": "Seleziona categoria",
      "rate": "Tariffa", 
      "years": "anni",
      "customDateTime": "Data/Ora personalizzata",
      
      // Footer
      "allRightsReserved": "Tutti i diritti riservati",
      "homeServices": "Servizi domestici",
      "termsConditions": "Termini e condizioni",
      "privacyPolicy": "Informativa sulla privacy",
      "contact": "Contatto",
      "importantNotice": "Avviso importante",
      "importantNoticeText": "Utilizzando SkillSOS, riconosci di aver letto, compreso e accettato di essere vincolato da questi Termini e Condizioni.",
      "yourRights": "I tuoi diritti",
      "yourRightsText": "Sotto il GDPR, hai diritti completi sui tuoi dati personali. Contattaci a admin@skillsos.bg per esercitare questi diritti.",
      
      // Enhanced Specialist Profile
      "verified": "Verificato",
      "new": "Nuovo",
      "review": "recensione",
      "reviews": "recensioni",
      "yearsExp": "Anni di esperienza",
      "reviewsCount": "recensioni",
      "satisfaction": "Soddisfazione",
      "responseTime": "Tempo di risposta",
      "availableToday": "Disponibile oggi",
      "bookThisSpecialist": "Prenota questo specialista",
      "startingFrom": "A partire da",
      "getInstantQuote": "Ottieni un preventivo istantaneo e prenota ora",
      "bookNow": "Prenota ora",
      "bookService": "Prenota servizio",
      "selectService": "Seleziona servizio",
      "chooseService": "Scegli un servizio",
      "selectDate": "Seleziona data",
      "selectTime": "Seleziona ora",
      "chooseTime": "Scegli ora",
      "duration": "Durata",
      "hour": "ora",
      "hours": "ore",
      "serviceAddress": "Indirizzo del servizio",
      "enterServiceAddress": "Inserisci indirizzo del servizio",
      "specialInstructions": "Istruzioni speciali",
      "anySpecialRequirements": "Eventuali requisiti speciali o note",
      "pricingSummary": "Riepilogo prezzi",
      "serviceRate": "Tariffa oraria",
      "totalEstimate": "Stima totale",
      "serviceSubtotal": "Importo del servizio",
      "serviceFee": "Commissione di servizio",
      "serviceFeeTooltip": "La commissione copre il pagamento sicuro e la manutenzione della piattaforma",
      "totalToPay": "Totale da pagare",
      "paymentHoldNote": "L'importo sarà trattenuto in modo sicuro fino al completamento del servizio. Il pagamento allo specialista viene effettuato dopo la tua conferma.",
      "applies": "si applica",
      "confirmBooking": "Conferma prenotazione",
      "processing": "Elaborazione",
      "message": "Messaggio",
      "call": "Chiama",
      "securePayment": "Pagamento sicuro",
      "instantBooking": "Prenotazione istantanea",
      "support247": "Supporto 24/7",
      
      // Review System
      "leaveReview": "Lascia una recensione",
      "howWasProvider": "Com'è stato {{name}}?",
      "onTimePunctual": "Puntuale",
      "professional": "Professionale",
      "respectful": "Rispettoso",
      "goodCommunication": "Buona comunicazione",
      "friendlyPleasant": "Amichevole e piacevole",
      "additionalCommentsOptional": "Commenti aggiuntivi (Opzionale)",
      "shareMoreDetails": "Condividi più dettagli sulla tua esperienza...",
      "characters": "caratteri",
      "reviewVisibilityNote": "Nota: La tua recensione sarà visibile a {{name}} solo dopo che entrambi avrete inviato le recensioni, o dopo 4 giorni.",
      "reviewSubmittedSuccess": "Recensione inviata con successo!",
      "reviewSubmitFailed": "Invio recensione non riuscito",
      "howWas": "Com'è stato",
      "additionalComments": "Commenti aggiuntivi (Opzionale)",
      "leaveAReview": "Lascia una recensione",
      "shareYourExperience": "Condividi la tua esperienza con",
      "overallRating": "Valutazione complessiva",
      "required": "*",
      "writeYourReview": "Scrivi la tua recensione (opzionale)",
      "tellUsMore": "Raccontaci di più sulla tua esperienza...",
      "rateAttributes": "Valuta attributi specifici",
      "punctual": "Puntuale",
      "professional": "Professionale",
      "respectful": "Rispettoso",
      "communicative": "Buona comunicazione",
      "friendly": "Amichevole e piacevole",
      "cancel": "Annulla",
      "submitReview": "Invia recensione",
      "submitting": "Invio in corso...",
      "myReviews": "Le mie recensioni",
      "totalReviews": "Recensioni totali",
      "noReviewsYet": "Nessuna recensione ancora",
      "reviewsWillAppearHere": "Le recensioni che ricevi appariranno qui",
      "thisUser": "questo utente",
      
      // Currencies
      "EUR": "EUR",
      
      // Calculator Link
      "calculator": "Calcolatrice",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'bg',
    lng: 'bg', // Force Bulgarian as default for all new visitors
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage'], // Only check localStorage (user's explicit choice), ignore browser settings
      caches: ['localStorage'],
    }
  });

export default i18n;